import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IFileSystem } from "../../dataingestion/types/IFileSystem";
import {
    DRAFT_AGREEMENTS_MAINTENANCE_PAGE,
    DRAFT_SET_LISTS_MAINTENANCE_PAGE,
    DRAFT_SET_LISTS_STATUS_DRAFT_TYPE,
    DRAFT_WORKS_MAINTENANCE_PAGE,
    INTRAY, LIVE_PERFORMANCE_END_TIME_STATE_KEY, LIVE_PERFORMANCE_MAINTENANCE_PAGE, LIVE_PERFORMANCE_OTHER_ARTIST_PERFORM_STATE_KEY, LIVE_PERFORMANCE_PERFORMANCE_DATE_STATE_KEY, LIVE_PERFORMANCE_PERFORMANCE_TYPE_STATE_KEY, LIVE_PERFORMANCE_PROMOTER_STATE_KEY, LIVE_PERFORMANCE_STAGE_STATE_KEY, LIVE_PERFORMANCE_START_TIME_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY, LIVE_PERFORMANCE_VENUE_LOOKUP_TYPE_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY, LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY, LIVE_PERFORMANCE_VENUE_OTHER_VENUE_TYPE_STATE_KEY, LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY, REGISTERED_WORKS_MAINTENANCE_PAGE, SEARCH_VIEW_CLAIMS_HISTORY, SEARCH_VIEW_DRAFT_WORKS, SEARCH_VIEW_REGISTERED_WORKS, SEARCH_VIEW_DRAFT_AGREEMENTS, SEARCH_VIEW_REGISTERED_AGREEMENTS, SEARCH_VIEW_ALL_REGISTERED_WORKS,
    UPLOAD_CUE_SHEET_PAGE,
    LIVE_PERFORMANCE_VENUE_NAME_STATE_KEY,
    LIVE_PERFORMANCE_VENUE_CODE_STATE_KEY,
    DRAFT_WORKS_STATE_KEY,
    DRAFT_WORKS_TITLES_STATE_KEY,
    CUE_SHEETS_MAINTENANCE_PAGE,
    SEARCH_VIEW_REGISTERED_CUE_SHEETS
} from "../../membersportal/Consts";
import {
    ActionTypes, AddTabAction, ApplyFormatsWorkMaintenance, ClearModalSearchResults, CloseWorkMaintenanceAccordian, CopyExistingDraftWork, CopyExistingRegisteredWork, CreateNewRegisteredWork, CreateNewDraftWork, DeleteDraftWorkFailure, DeleteDraftWorkRequest, DeleteDraftWorkSuccess, DeleteRegisteredWorkFailure, DeleteRegisteredWorkRequest, DeleteRegisteredWorkSuccess, EnableCustomField, ExpandAllResults, GetDraftWorkDetailsFailure, GetDraftWorkIDsFailure, GetDraftWorkIDsRequest, GetDraftWorkIDsSuccess, GetDraftWorkDetailsRequest, GetDraftWorkDetailsSuccess, GetFormatFieldsFailure, GetFormatFieldsRequest, GetFormatFieldsSuccess, GetUserPreferenceFailure, GetUserPreferenceRequest, GetUserPreferenceSuccess, GetUsersFailure, GetUsersRequest, GetUsersSuccess, GetRegisteredWorkFailure, GetRegisteredWorkIDsFailure, GetRegisteredWorkIDsRequest, GetRegisteredWorkIDsSuccess, GetRegisteredWorkRequest, GetRegisteredWorkSuccess, IncrementTempID, MembersPortalComponentDataFailure, MembersPortalComponentDataRequest, MembersPortalComponentDataSuccess, MP_ADD_TAB, MP_APPLY_FORMATS_WORK_MAINTENANCE, MP_CLEAR_MODAL_SEARCH_RESULTS, MP_CLOSE_ACCORDION, MP_COPY_REGISTERED_WORK, MP_CREATE_NEW_REGISTERED_WORK, MP_COPY_DRAFT_WORK, MP_CREATE_NEW_DRAFT_WORK, MP_DELETE_DRAFT_WORK_FAILURE, MP_DELETE_DRAFT_WORK_REQUEST, MP_DELETE_DRAFT_WORK_SUCCESS, MP_ENABLE_CUSTOM_FIELD, MP_DELETE_REGISTERED_WORK_FAILURE, MP_DELETE_REGISTERED_WORK_REQUEST, MP_DELETE_REGISTERED_WORK_SUCCESS, MP_EXPAND_ALL_RESULTS, MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_FAILURE, MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_REQUEST, MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_SUCCESS, MP_GET_DRAFT_WORK_ID_FAILURE, MP_GET_DRAFT_WORK_ID_REQUEST, MP_GET_DRAFT_WORK_ID_SUCCESS, MP_GET_FORMAT_FIELDS_FAILURE, MP_GET_FORMAT_FIELDS_REQUEST, MP_GET_FORMAT_FIELDS_SUCCESS, MP_GET_USERS_FAILURE, MP_GET_USERS_REQUEST, MP_GET_USERS_SUCCESS, MP_GET_USER_PREFERENCES_FAILURE, MP_GET_USER_PREFERENCES_REQUEST, MP_GET_USER_PREFERENCES_SUCCESS, MP_INCREMENT_TEMPID, MP_OPEN_ACCORDION, MP_OPEN_TAB, MP_REMOVE_TAB, MP_GET_REGISTERED_WORK_FAILURE, MP_GET_REGISTERED_WORK_ID_FAILURE, MP_GET_REGISTERED_WORK_ID_REQUEST, MP_GET_REGISTERED_WORK_ID_SUCCESS, MP_GET_REGISTERED_WORK_REQUEST, MP_GET_REGISTERED_WORK_SUCCESS, MP_REPLACE_TAB, MP_RESET_MESSAGE_BANNER, MP_RESET_PAGINATION, MP_SAVE_DRAFT_WORK_FAILURE, MP_SAVE_DRAFT_WORK_REQUEST, MP_SAVE_DRAFT_WORK_SUCCESS, MP_SEARCH_DRAFT_WORKS_FAILURE, MP_SEARCH_DRAFT_WORKS_REQUEST, MP_SEARCH_DRAFT_WORKS_SUCCESS, MP_SAVE_REGISTERED_WORK_FAILURE, MP_SAVE_REGISTERED_WORK_REQUEST, MP_SAVE_REGISTERED_WORK_SUCCESS, MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_FAILURE, MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_REQUEST, MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_SUCCESS, MP_SET_CHANGES_MADE, MP_SET_EDITABLE_FIELDS_TAB, MP_SET_WARNING_MESSAGE, MP_SORT_SEARCH_RESULTS, MP_UNDO_DRAFT_WORK_CHANGES_FAILURE, MP_SEARCH_REGISTERED_WORKS_FAILURE, MP_SEARCH_REGISTERED_WORKS_REQUEST, MP_SEARCH_REGISTERED_WORKS_SUCCESS, MP_UNDO_DRAFT_WORK_CHANGES_REQUEST, MP_UNDO_DRAFT_WORK_CHANGES_SUCCESS, MP_UPDATE_COMPONENT_FIELD_FAILURE, MP_UPDATE_COMPONENT_FIELD_REQUEST, MP_UPDATE_COMPONENT_FIELD_SUCCESS, MP_UPDATE_DRAFT_WORK_FIELD, MP_UPDATE_EDITABLE_FIELD, MP_UNDO_REGISTERED_WORK_CHANGES_FAILURE, MP_UNDO_REGISTERED_WORK_CHANGES_REQUEST, MP_UNDO_REGISTERED_WORK_CHANGES_SUCCESS, MP_UPDATE_PAGINATION, MP_UPDATE_USER_PREFERENCE, MP_UPDATE_REGISTERED_WORK_FIELD, OpenAccordion, OpenTabAction, RemoveTabAction, ReplaceTabAction, ResetMessageBanner, ResetPagination, SaveDraftWorkFailure, SaveDraftWorkRequest, SaveDraftWorkSuccess, SearchDraftWorksFailure, SaveRegisteredWorkFailure, SaveRegisteredWorkRequest, SaveRegisteredWorkSuccess, SearchDraftWorksRequest, SearchDraftWorksSuccess, SearchDraftWorkVersionHistoryFailure, SearchDraftWorkVersionHistoryRequest, SearchDraftWorkVersionHistorySuccess, SetChangesMade, SetDataSourceAction, SetEditableFields, SearchRegisteredWorksFailure, SearchRegisteredWorksRequest, SearchRegisteredWorksSuccess, SetWarningMessage, SET_DATA_SOURCE, SortSearchResults, UndoDraftWorkChangesFailure, UndoDraftWorkChangesRequest, UndoDraftWorkChangesSuccess, UpdateComponentFieldFailure, UpdateComponentFieldRequest, UpdateComponentFieldSuccess, UpdateDraftWorkField, UpdateEditableField, UpdatePagination, UndoRegisteredWorkChangesFailure, UndoRegisteredWorkChangesRequest, UndoRegisteredWorkChangesSuccess, UpdateUserPreference, MP_GET_DRAFT_WORK_DETAILS_REQUEST, MP_GET_DRAFT_WORK_DETAILS_SUCCESS, MP_GET_DRAFT_WORK_DETAILS_FAILURE, UpdateRegisteredWorkField, MP_UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS, MP_UPDATE_WORK_CONTRIBUTOR_IP_REQUEST, UpdateWorkContributorIPRequest, UpdateWorkContributorIPFailure, MP_UPDATE_WORK_CONTRIBUTOR_IP_FAILURE, UpdateWorkContributorIPSuccess, MP_SEARCH_CONTRIBUTORS_REQUEST, SearchContributorRequest, SearchContributorsSuccess, MP_SEARCH_CONTRIBUTORS_SUCCESS, MP_SEARCH_CONTRIBUTORS_FAILURE, SearchContributorsFailure, MP_SEARCH_ARTISTS_REQUEST, MP_SEARCH_ARTISTS_SUCCESS, MP_SEARCH_ARTISTS_FAILURE, SearchArtistsFailure, SearchArtistsSuccess, SearchArtistsRequest, AddArtistToWork, MP_ADD_ARTIST_TO_WORK, MP_GET_REGISTERED_WORK_DETAILS_REQUEST, MP_GET_REGISTERED_WORK_DETAILS_SUCCESS, MP_GET_REGISTERED_WORK_DETAILS_FAILURE, GetRegisteredWorkDetailsRequest, GetRegisteredWorkDetailsSuccess, GetRegisteredWorkDetailsFailure, AddRepertoireAttachmentRequest, MP_ADD_REPERTOIRE_ATTACHMENT_REQUEST, AddRepertoireAttachmentSuccess, MP_ADD_REPERTOIRE_ATTACHMENT_SUCCESS, AddRepertoireAttachmentFailure, MP_ADD_REPERTOIRE_ATTACHMENT_FAILURE, RemoveWorkAttachmentRequest, MP_REMOVE_WORK_ATTACHMENT_REQUEST, RemoveWorkAttachmentSuccess, MP_REMOVE_WORK_ATTACHMENT_SUCCESS, MP_REMOVE_WORK_ATTACHMENT_FAILURE, RemoveWorkAttachmentFailure, RemoveAgreementAttachmentRequest, MP_REMOVE_AGREEMENT_ATTACHMENT_REQUEST, RemoveAgreementAttachmentSuccess, MP_REMOVE_AGREEMENT_ATTACHMENT_SUCCESS, RemoveAgreementAttachmentFailure, MP_REMOVE_AGREEMENT_ATTACHMENT_FAILURE, SetProgressUploadFileRepertoireProccess, MP_SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE, CleanDroppedFilesState, MP_CLEAN_DROPPED_FILES_STATE, MP_ADD_DROPPED_FILE, AddDroppedFile, SearchAllRegisteredWorksFailure, MP_SEARCH_ALL_REGISTERED_WORKS_FAILURE, MP_SEARCH_ALL_REGISTERED_WORKS_SUCCESS, SearchAllRegisteredWorksSuccess, MP_SEARCH_ALL_REGISTERED_WORKS_REQUEST, SearchAllRegisteredWorksRequest, MP_GET_ALL_REGISTERED_WORK_DETAILS_REQUEST, MP_GET_ALL_REGISTERED_WORK_DETAILS_SUCCESS, MP_GET_ALL_REGISTERED_WORK_DETAILS_FAILURE, GetAllRegisteredWorkDetailsRequest, GetAllRegisteredWorkDetailsSuccess, GetAllRegisteredWorkDetailsFailure, MP_EXPAND_WORK_RESULT, ExpandWorkResult, ReisterStepsSetCurrent, MP_REGISTER_STEPS_SET_CURRENT, SearchRequestAccessIP, MP_SEARCH_REQUEST_ACCESS_IP, MP_SEARCH_REQUEST_ACCESS_IP_SUCCESS, MP_SEARCH_REQUEST_ACCESS_IP_FAILURE, SearchRequestAccessIPSuccess, SearchRequestAccessIPFailure, RequestViewAsAccessSuccess, RequestViewAsAccessFailure, MP_REQUEST_VIEW_AS_ACCESS_SUCCESS, MP_REQUEST_VIEW_AS_ACCESS_FAILURE, RequestViewAsAccess, MP_REQUEST_VIEW_AS_ACCESS, MP_GET_VIEW_AS_ACCESS_REQUESTS, MP_GET_VIEW_AS_ACCESS_REQUESTS_SUCCESS, MP_GET_VIEW_AS_ACCESS_REQUESTS_FAILURE, GetViewAsAccessRequests, GetViewAsAccessRequestsSuccess, GetViewAsAccessRequestsFailure, SaveViewAsAccess, MP_SAVE_VIEW_AS_ACCESS, MP_SAVE_VIEW_AS_ACCESS_SUCCESS, MP_SAVE_VIEW_AS_ACCESS_FAILURE, SaveViewAsAccessSuccess, SaveViewAsAccessFailure, CancelAccessRequest, CancelAccessRequestSuccess, CancelAccessRequestFailure, MP_CANCEL_ACCESS_REQUEST, MP_CANCEL_ACCESS_REQUEST_SUCCESS, MP_CANCEL_ACCESS_REQUEST_FAILURE, SearchMemberStatementsRequest, MP_SEARCH_STATEMENTS_REQUEST, SearchMemberStatementsSuccess, MP_SEARCH_STATEMENTS_SUCCESS, SearchMemberStatementsFailure, MP_SEARCH_STATEMENTS_FAILURE, ExpandMemberStatementResult, MP_EXPAND_STATEMENT_RESULT, MP_GET_STATEMENT_DETAILS_REQUEST, MP_GET_STATEMENT_DETAILS_SUCCESS, MP_GET_STATEMENT_DETAILS_FAILURE, GetMemberStatementDetailsRequest, GetMemberStatementDetailsSuccess, GetMemberStatementDetailsFailure, MP_SEARCH_DRAFT_SET_LISTS_FAILURE, MP_SEARCH_DRAFT_SET_LISTS_SUCCESS, MP_SEARCH_DRAFT_SET_LISTS_REQUEST, SearchDraftSetListsRequest, SearchDraftSetListsSuccess, SearchDraftSetListsFailure, MP_RESET_VIEW_AS_SAVE_STATUS, ResetViewAsSaveStatus, MP_SEARCH_REGISTERED_SET_LISTS_REQUEST, SearchRegisteredSetListsRequest, SearchRegisteredSetListsSuccess, MP_SEARCH_REGISTERED_SET_LISTS_SUCCESS, MP_SEARCH_REGISTERED_SET_LISTS_FAILURE, SearchRegisteredSetListsFailure, MP_CREATE_NEW_DRAFT_SET_LISTS, CreateNewDraftSetLists, MP_COPY_DRAFT_SET_LIST, CopyExistingDraftSetList, SaveDraftSetListsRequest, MP_SAVE_DRAFT_SET_LISTS_REQUEST, SaveDraftSetListsSuccess, MP_SAVE_DRAFT_SET_LISTS_SUCCESS, MP_SAVE_DRAFT_SET_LISTS_FAILURE, SaveDraftSetListsFailure, MP_UPDATE_DRAFT_SET_LISTS_FIELD, DeleteDraftSetListRequest, MP_DELETE_DRAFT_SET_LIST_REQUEST, DeleteDraftSetListSuccess, MP_DELETE_DRAFT_SET_LIST_SUCCESS, DeleteDraftSetListFailure, MP_DELETE_DRAFT_SET_LIST_FAILURE, UpdateDraftSetListsField, MP_ADD_WORK_TO_SET_LIST, AddWorkToSetList, MP_GET_DRAFT_SET_LIST_DETAILS_FAILURE, MP_GET_REGISTERED_SET_LIST_DETAILS_REQUEST, MP_GET_REGISTERED_SET_LIST_DETAILS_SUCCESS, MP_GET_REGISTERED_SET_LIST_DETAILS_FAILURE, MP_GET_DRAFT_SET_LIST_DETAILS_SUCCESS, MP_GET_DRAFT_SET_LIST_DETAILS_REQUEST, GetDraftSetListDetailsRequest, GetDraftSetListDetailsSuccess, GetDraftSetListDetailsFailure, GetRegisteredSetListDetailsSuccess, GetRegisteredSetListDetailsRequest, GetRegisteredSetListDetailsFailure, MP_CREATE_NEW_LIVE_PERFORMANCE, MP_UPDATE_LIVE_PERFORMANCE_FIELD, UpdateLivePerformanceField, UpdateLivePerformanceSetListAdditionalField, MP_UPDATE_LIVE_PERFORMANCE_SET_LIST_ADDITIONAL_FIELD, UpdateLivePerformanceVenueDetailsField, MP_UPDATE_LIVE_PERFORMANCE_VENUE_DETAILS_FIELD, MP_COPY_DRAFT_LIVE_PERFORMANCE, CopyExistingDraftLivePerformance, MP_CREATE_NEW_DRAFT_LIVE_PERFORMANCE, CreateNewDraftLivePerformance, MP_UNDO_DRAFT_SET_LIST_CHANGES_SUCCESS, MP_UNDO_DRAFT_SET_LIST_CHANGES_FAILURE, MP_UNDO_DRAFT_SET_LIST_CHANGES_REQUEST, UndoDraftSetListChangesRequest, UndoDraftSetListChangesSuccess, UndoDraftSetListChangesFailure, AddSetListToLivePerformance, MP_ADD_SET_LIST_TO_LIVE_PERFORMANCE, SaveDraftLivePerformanceSuccess, MP_SAVE_DRAFT_LIVE_PERFORMANCE_SUCCESS, SaveDraftLivePerformanceFailure, MP_SAVE_DRAFT_LIVE_PERFORMANCE_FAILURE, SearchLivePerformancesRequest, MP_SEARCH_LIVE_PERFORMANCES_REQUEST, SearchLivePerformancesFailure, MP_SEARCH_LIVE_PERFORMANCES_FAILURE, MP_SEARCH_LIVE_PERFORMANCES_SUCCESSS, SearchLivePerformancesSuccess, GetLivePerformanceDetailsRequest, MP_GET_LIVE_PERFORMANCE_DETAILS_REQUEST, GetLivePerformanceDetailsSuccess, MP_GET_LIVE_PERFORMANCE_DETAILS_SUCCESS, GetLivePerformanceDetailsFailure, MP_GET_LIVE_PERFORMANCE_DETAILS_FAILURE, MP_SEARCH_UNPAID_CLAIMS_REQUEST, SearchUnpaidClaimsRequest, SearchUnpaidClaimsSuccess, MP_SEARCH_UNPAID_CLAIMS_SUCCESS, MP_SEARCH_UNPAID_CLAIMS_FAILURE, SearchUnpaidClaimsFailure, GetShareDecimalsToDisplayRequest, MP_GET_SHARE_DECIMALS_TO_DISPLAY_REQUEST, GetShareDecimalsToDisplaySuccess, MP_GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS, GetShareDecimalsToDisplayFailure, MP_GET_SHARE_DECIMALS_TO_DISPLAY_FAILURE, MP_UPDATE_DRAFT_AGREEMENT_FIELD,
    RefreshWorkDetailsRequest, RefreshWorkDetailsSuccess, RefreshWorkDetailsFailure, MP_REFRESH_WORK_DETAILS_REQUEST, MP_REFRESH_WORK_DETAILS_SUCCESS, MP_REFRESH_WORK_DETAILS_FAILURE, MP_SAVE_WORK_CONTRIBUTOR_COMMENT, SaveContributorComment, SearchClaimsHistoryRequest, MP_SEARCH_CLAIMS_HISTORY_REQUEST, SearchClaimsHistorySuccess, MP_SEARCH_CLAIMS_HISTORY_SUCCESS, SearchClaimsHistoryFailure, MP_SEARCH_CLAIMS_HISTORY_FAILURE, MP_CLAIM_UNPAID_USAGE_SUCCESS, MP_CLAIM_UNPAID_USAGE_REQUEST, ClaimUnpaidUsageRequest, ClaimUnpaidUsageFailure, MP_CLAIM_UNPAID_USAGE_FAILURE, ClaimUnpaidUsageSuccess,
    SearchDraftAgreementsFailure,
    MP_SEARCH_DRAFT_AGREEMENTS_REQUEST,
    MP_SEARCH_DRAFT_AGREEMENTS_SUCCESS,
    MP_SEARCH_DRAFT_AGREEMENTS_FAILURE,
    SearchDraftAgreementsSuccess,
    SearchDraftAgreementsRequest,
    GetDraftAgreementDetailsRequest,
    MP_GET_DRAFT_AGREEMENT_DETAILS_REQUEST,
    GetDraftAgreementDetailsSuccess,
    MP_GET_DRAFT_AGREEMENT_DETAILS_SUCCESS,
    GetDraftAgreementDetailsFailure,
    MP_GET_DRAFT_AGREEMENT_DETAILS_FAILURE,
    MP_SEARCH_REGISTERED_AGREEMENTS_FAILURE,
    SearchRegisteredAgreementsRequest,
    MP_SEARCH_REGISTERED_AGREEMENTS_REQUEST,
    MP_SEARCH_REGISTERED_AGREEMENTS_SUCCESS,
    SearchRegisteredAgreementsFailure,
    SearchRegisteredAgreementsSuccess,
    MP_CREATE_NEW_DRAFT_AGREEMENT,
    CreateNewDraftAgreement,
    MP_SEARCH_DRAFT_AGREEMENTS_IP_REQUEST,
    MP_SEARCH_DRAFT_AGREEMENTS_IP_SUCCESS,
    SearchDraftAgreementsIPFailure,
    MP_SEARCH_DRAFT_AGREEMENTS_IP_FAILURE,
    SearchDraftAgreementsIPRequest,
    SearchDraftAgreementsIPSuccess,
    UpdateDraftAgreementField,
    SearchDraftAgreementsWorksSuccess,
    SearchDraftAgreementsWorksRequest,
    SearchDraftAgreementsWorksFailure,
    MP_SEARCH_DRAFT_AGREEMENTS_WORKS_FAILURE,
    MP_SEARCH_DRAFT_AGREEMENTS_WORKS_SUCCESS,
    MP_SEARCH_DRAFT_AGREEMENTS_WORKS_REQUEST,
    UpdateDraftAgreementWorkField,
    SaveDraftAgreementRequest,
    MP_SAVE_DRAFT_AGREEMENT_REQUEST,
    SaveDraftAgreementSuccess,
    MP_SAVE_DRAFT_AGREEMENT_SUCCESS,
    SaveDraftAgreementFailure,
    MP_SAVE_DRAFT_AGREEMENT_FAILURE,
    RefreshAgreementDetailsRequest,
    MP_REFRESH_AGREEMENT_DETAILS_REQUEST,
    RefreshAgreementDetailsSuccess,
    MP_REFRESH_AGREEMENT_DETAILS_SUCCESS,
    RefreshAgreementDetailsFailure,
    MP_REFRESH_AGREEMENT_DETAILS_FAILURE,
    GetMyApplications,
    MP_GET_MY_APPLICATIONS,
    MP_GET_MY_APPLICATIONS_FAILURE,
    MP_GET_MY_APPLICATIONS_SUCCESS,
    GetMyApplicationsFailure,
    GetMyApplicationsSuccess,
    GetMyCases,
    GetMyCasesFailure,
    GetMyCasesSuccess,
    MP_GET_MY_CASES,
    MP_GET_MY_CASES_FAILURE,
    MP_GET_MY_CASES_SUCCESS,
    GetCRMIntegratedRequest,
    GetCRMIntegratedSuccess,
    GetCRMIntegratedFailure,
    GetCRMPowerPortalBaseURLRequest,
    GetCRMPowerPortalBaseURLFailure,
    GetCRMPowerPortalBaseURLSuccess,
    MP_UPDATE_DRAFT_AGREEMENT_WORK_FIELD,
    MP_GET_CRM_POWER_PORTAL_BASE_URL_REQUEST,
    MP_GET_CRM_POWER_PORTAL_BASE_URL_SUCCESS,
    MP_GET_CRM_POWER_PORTAL_BASE_URL_FAILURE,
    MP_GET_CRM_INTEGRATION_ENABLED_REQUEST,
    MP_GET_CRM_INTEGRATION_ENABLED_SUCCESS,
    MP_GET_CRM_INTEGRATION_ENABLED_FAILURE,
    ADD_TO_PACKAGE_SUCCESS_MP,
    AddToPackageSuccessMP,
    MP_DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS,
    GetDefaultUseRelationshipFlag,
    GetSubmitterMustBeAssociatedWithAgreementFlag,
    MP_SUBMITTER_MUST_BE_ASSOCIATED_FLAG_SUCCESS,
    SearchCueSheetsRequest,
    MP_SEARCH_CUE_SHEETS_REQUEST,
    MP_SEARCH_CUE_SHEETS_SUCCESS,
    MP_SEARCH_CUE_SHEETS_FAILURE,
    SearchCueSheetsFailure,
    SearchCueSheetsSuccess,
    GetCueSheetsDetailsRequest,
    GetCueSheetsDetailsSuccess,
    GetCueSheetsDetailsFailure,
    MP_GET_CUE_SHEET_DETAILS_REQUEST,
    MP_GET_CUE_SHEET_DETAILS_SUCCESS,
    MP_GET_CUE_SHEET_DETAILS_FAILURE,
    MP_UPLOAD_CUE_FILES_SHEETS,
    UploadCueSheetsRequest,
    MP_DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS,
    GetDefaultIsAppliedAtIPNameNumberLevelflag,
    GetEnabledSetTypeBundleRequest,
    GetEnabledSetTypeBundleSuccess,
    GetEnabledSetTypeBundleFailure,
    GET_ENABLED_SET_TYPE_BUNDLE_REQUEST,
    GET_ENABLED_SET_TYPE_BUNDLE_SUCCESS,
    GET_ENABLED_SET_TYPE_BUNDLE_FAILURE,
    GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_FAILURE,
    GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_REQUEST,
    GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_SUCCESS,
    GetSetListWorkDefaultDurationFailure,
    GetSetListWorkDefaultDurationSuccess,
    GetSetListWorkDefaultDurationRequest,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_FAILURE,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_REQUEST,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS,
    GetWorkContributorDefaultLegalEntityValueFailure,
    GetWorkContributorDefaultLegalEntityValueRequest,
    GetWorkContributorDefaultLegalEntityValueSuccess,
    ExpandProductResult,
    MP_EXPAND_PRODUCT_RESULT,
    GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_FAILURE,
    GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_REQUEST,
    GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_SUCCESS,
    GetShareSetsShownInPortalFailure,
    GetShareSetsShownInPortalRequest,
    GetShareSetsShownInPortalSuccess,
    SearchLicenseVenuesFailure,
    MP_SEARCH_LICENSE_VENUES_FAILURE,
    SEARCH_LICENSE_VENUES_REQUEST,
    SearchLicenseVenuesRequest,
    SearchLicenseVenuesSuccess,
    MP_SEARCH_LICENSE_VENUES_SUCCESS,
    MP_ADD_LICENSE_VENUE_TO_USAGE,
    GetAssigneeAgreementsRequest,
    MP_GET_ASSIGNEE_AGREEMENTS_REQUEST,
    GetAssigneeAgreementsSuccess,
    GetAssigneeAgreementsFailure,
    MP_GET_ASSIGNEE_AGREEMENTS_SUCCESS,
    MP_GET_ASSIGNEE_AGREEMENTS_FAILURE,
    GetMemberStatementPowerBiEmbedFailure,
    GetMemberStatementPowerBiEmbedSuccess,
    GetMemberStatementPowerBiEmbedRequest,
    MP_GET_STATEMENT_POWERBI_EMBED_FAILURE,
    MP_GET_STATEMENT_POWERBI_EMBED_REQUEST,
    MP_GET_STATEMENT_POWERBI_EMBED_SUCCESS,
    MP_RESET_POWER_BI_EMBED_TOKEN,
    ResetPowerBiEmbedToken,
    GetFullCataloguePackagePendingSuccess,
    GetFullCataloguePackagePendingFailure,
    MP_GET_FULL_CATALOGUE_PACKAGE_PENDING_SUCCESS,
    MP_GET_FULL_CATALOGUE_PACKAGE_PENDING_FAILURE,
    CreatePackageFromCriteriaRequest,
    CreatePackageFromCriteriaSuccess,
    CreatePackageFromCriteriaFailure,
    MP_CREATE_PACKAGE_FROM_CRITERIA_REQUEST,
    MP_CREATE_PACKAGE_FROM_CRITERIA_SUCCESS,
    MP_CREATE_PACKAGE_FROM_CRITERIA_FAILURE,
    GetPowerBIAnalyticsConfigurationSuccess,
    MP_GET_POWER_BI_ANALYTICS_CONFIGURATION_SUCCESS,
    GET_DEFAULT_SET_TYPE_GROUP_CONFIG_REQUEST,
    GET_DEFAULT_SET_TYPE_GROUP_CONFIG_SUCCESS,
    GET_DEFAULT_SET_TYPE_GROUP_CONFIG_FAILURE,
    GetDefaultSetTypeGroupRequest,
    GetDefaultSetTypeGroupSuccess,
    GetDefaultSetTypeGroupFailure,
    GET_PORTAL_WORK_STATUS_CONFIGURATION_FAILURE,
    GET_PORTAL_WORK_STATUS_CONFIGURATION_REQUEST,
    GET_PORTAL_WORK_STATUS_CONFIGURATION_SUCCESS,
    GetPortalWorkStatusConfigurationFailure,
    GetPortalWorkStatusConfigurationRequest,
    GetPortalWorkStatusConfigurationSuccess,
} from "../actions/MembersPortalActions";
import { IActiveAccordion } from "../types/IActiveAccordion";
import { IDraftWorkSearchResult } from "../../membersportal/types/IDraftWorkSearchResult";
import { IDraftWorkVersionHistorySearchResult } from "../../membersportal/types/IDraftWorkVersionHistorySearchResult";
import IMembersPortalState from "../types/IMembersPortalState";
import { ITabReduxItem } from "../types/ITabReduxItem";
import { IValidationMessage } from "../../repertoire/types/IValidationMessage";
import { FormatFields } from "../types/FormatFields";
import { IResultsPerPage } from "../types/IResultsPerPage";
import { IDataActionToolbar } from "../../membersportal/types/IDataActionToolbar";
import { IMembersPortalStateKeys } from "../../membersportal/types/IMembersPortalStateKeys";
import IMembersPortalComponentData from "../types/IMembersPortalComponentData";
import IMembersPortalComponentDataItem from "../types/IMembersPortalComponentDataItem";
import { IMembersPortalField } from "../../membersportal/types/IMembersPortalField";
import { IRegisteredWork } from "../../membersportal/types/IRegisteredWork";
import { IWork } from "../../repertoire/types/IWork";
import { IWorkState, IWorkStateKeys } from "../types/IWorkState";
import { WorkDetailsMapper } from "../../repertoire/services/WorkDetailsMapper";
import { IWorkSaveResult } from "../../repertoire/types/IWorkSaveResult";
import { IRegisteredWorkSearchResult } from "../../membersportal/types/IRegisteredWorkSearchResult";
import { IContributorItem } from "../../repertoire/types/IContributorItem";
import { BOOLEAN_READONLY_INPUT, DEFINITE_MATCH, DROPDOWN_INPUT, GLOBAL, READ_ONLY_INPUT, TIMESPAN_INPUT } from "../../repertoire/Consts";
import { IP } from "../../repertoire/types/IP";
import { IAgreementLink } from "../../repertoire/types/IAgreementLink";
import { IContributorSearchResult } from "../../membersportal/types/IContributorSearchResult";
import { IArtist } from "../../repertoire/types/IArtist";
import { DataSource } from "../../repertoire/types/DataSource";
import { IAttachedFile } from "../types/IAttachedFile";
import IFile from "../types/IFiles";
import IDroppedFiles from "../types/IDroppedFiles";
import { IAllRegisteredWorkSearchResult } from "../../membersportal/types/IAllRegisteredWorkSearchResult";
import { IViewAsAccessRequest } from "../../membersportal/types/IViewAsAccessRequest";
import { IMemberStatementSearchResult } from "../../membersportal/types/IMemberStatementSearchResult";
import { IDraftSetListSearchResult } from "../../membersportal/types/IDraftSetListSearchResult";
import { IRegisteredSetListsSearchResults } from "../../membersportal/types/IRegisteredSetListsSearchResults";
import { ISetListsStateKeys } from "../../membersportal/types/ISetListsState";
import { ProductDetailsMapper } from "../../repertoire/services/ProductDetailsMapper";
import { IProductState } from "../types/IProductState";
import { IProductSaveResult } from "../../repertoire/types/IProductSaveResult";
import { IProductCore } from "../../repertoire/types/IProductCore";
import { UsageDetailsMapper } from "../../repertoire/services/usageServices/UsageDetailsMapper";
import { IUsageGroupStateKeys } from "../types/IUsageGroupState";
import { IUsageGroupSetListAdditionalStateKeys } from "../../repertoire/types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageGroupVenueDetailsStateKeys } from "../../repertoire/types/usageTypes/IUsageGroupVenueDetails";
import { IUsageSaveResult } from "../../repertoire/types/usageTypes/IUsageSaveResult";
import { ILivePerformancesSearchResult } from "../../membersportal/types/ILivePerformancesSearchResult";
import { IUsageGroup } from "../../repertoire/types/usageTypes/IUsageGroup";
import { ShowModal, SHOW_MODAL } from "../actions/ModalActions";
import { ADD_TO_PACKAGE_FAILURE, ADD_TO_PACKAGE_REQUEST, ADD_TO_PACKAGE_SUCCESS, GENERATE_PACKAGE_FAILURE, GENERATE_PACKAGE_REQUEST, GENERATE_PACKAGE_SUCCESS, GET_ALL_PACKAGES_DETAILS_SUCCESS, GET_MATCHING_SOURCES_SUCCESS, GET_USAGEDISTR_SUCCESS, MY_PACKAGES_DOWNLOAD_FORMAT_SUCCESS } from "../actions/RepertoireActions";
import { ISourceSearchResult } from "../../settings/types/ISourceSearchResult";
import { ITreeData } from "../../repertoire/types/ITreeData";
import { IUnpaidClaimsSearchResult } from "../../membersportal/types/IUnpaidClaimsSearchResult";
import { IClaimsHistorySearchResult } from "../../membersportal/types/IClaimsHistorySearchQuery";
import { IDraftAgreementSearchResult } from "../../membersportal/types/IDraftAgreementsSearchResult";
import { IAgreement } from "../../repertoire/types/IAgreement";
import { IRegisteredAgreementSearchResult } from "../../membersportal/types/IRegisteredAgreementSearchResult";
import { AgreementDetailsMapper } from "../../repertoire/services/AgreementDetailsMapper";
import { IIPsSearchResult } from "../../repertoire/types/IIPsSearchResult";
import { IAgreementStateKeys } from "../types/IAgreementState";
import { IWorksSearchResult } from "../../repertoire/types/IWorksSearchResult";
import { IAgreementSaveResult } from "../../repertoire/types/IAgreementSaveResult";
import { IApplication } from "../../membersportal/types/IApplication";
import { ICase } from "../../membersportal/types/ICase";
import { IAddtoPackageResult } from "../../repertoire/types/IAddtoPackageResult";
import { ICueSheetsSearchResult } from "../../membersportal/types/ICueSheetsSearchResult";
import { GET_UPLOAD_CUE_SHEETS_REQUEST, GET_UPLOAD_CUE_SHEETS_SUCCESS, GET_UPLOAD_CUE_SHEETS_FAILURE } from "../actions/DataIngestionActions";
import { IStoragePathItemData } from "../../dataingestion/types/IStoragePathItemData";
import { Dictionary } from "../../core/types/Dictionary";
import { IPortalShareSetConfiguration } from "../../membersportal/types/IPortalShareSetConfiguration";
import { ILicenseCustomerVenue } from "../../repertoire/types/ILicenseCustomerVenue";
import { IAssigneeAgreementResult } from "../../membersportal/types/IAssigneeAgreementResult";
import { IPowerBIEmbedParams } from "../../memberspo../../membersportal/types/IPowerBIEmbedParams";
import { IMyPackagesDetails } from "../../repertoire/types/IMyPackagesDetails";
import { IPowerBIAnalyticsConfig } from "../../membersportal/types/IPowerBIAnalyticsConfig";
import { formatAttachmentLastModifiedForDisplay } from "../../membersportal/util/dateHelpers";
import { CURRENT_USER_NAME_KEY } from "../services/AccountSessionStorage";
import { v4 as uuidv4 } from "uuid";
import { IPortalWorkStatusConfiguration } from "../../membersportal/types/IPortalWorkStatusConfiguration";
import { MEMBERS_PORTAL } from "../../accounts/Consts";

const initialState: IMembersPortalState = {
    tabs: [],
    dataSource: INTRAY,
    componentData: {
        SearchView: {
            fields: []
        },
        SearchResultsTable: {
            fields: []
        },
        DataGridTable: {
            fields: []
        },
        SaveResult: {
            fields: []
        },
        LoadingView: {
            fields: []
        },
        YesNoPromptView: {
            fields: []
        },
        TabsView: {
            fields: []
        },
        DraftWorksPage: {
            fields: []
        },
        DraftAgreementsPage: {
            fields: []
        },
        DraftAgreementsMaintenanceGeneralDataView: {
            fields: []
        },
        RegisteredAgreementsPage: {
            fields: []
        },
        RegisteredAgreementMaintenanceGeneralDataView: {
            fields: []
        },
        DraftWorkMaintenanceGeneralDataView: {
            fields: []
        },
        DraftWorkMaintenanceToolbar: {
            fields: []
        },
        DraftWorkMaintenanceGridsViewData: {
            fields: []
        },
        DraftSetListsPage: {
            fields: []
        },
        DraftSetListsMaintenanceGeneralDataView: {
            fields: []
        },
        CueSheetsMaintenanceGeneralDataView: {
            fields: []
        },
        DraftSetListsMaintenanceToolbar: {
            fields: []
        },
        DraftSetListsMaintenanceGridsViewData: {
            fields: []
        },
        CueSheetsMaintenanceGridsViewData: {
            fields: []
        },
        MembersPortalSideMenuDataView: {
            fields: []
        },
        MembersPortalPageDataView: {
            fields: []
        },
        RegisteredWorksPage: {
            fields: []
        },
        RegisteredSetListsPage: {
            fields: []
        },
        AllRegisteredCueSheetsPage: {
            fields: []
        },
        MyRegisteredCueSheetsPage: {
            fields: []
        },
        MyDraftCueSheetsPage: {
            fields: []
        },
        UploadCueSheetsMaintenanceGridsViewData: {
            fields: []
        },
        UploadCueSheetsPage: {
            fields: []
        },
        UploadCueSheetsMaintenanceToolbar: {
            fields: []
        },
        CueSheetsPage: {
            fields: []
        },
        RegisteredWorkMaintenanceGeneralDataView: {
            fields: []
        },
        RegisteredWorkMaintenanceToolbar: {
            fields: []
        },
        RegisteredWorkMaintenanceGridsViewData: {
            fields: []
        },
        AllRegisteredWorkMaintenanceGeneralDataView: {
            fields: []
        },
        AllRegisteredWorkMaintenanceGridsViewData: {
            fields: []
        },
        AllRegisteredWorkMaintenanceToolbar: {
            fields: []
        },
        AllRegisteredWorksPage: {
            fields: []
        },
        MyPackagesPage: {
            fields: []
        },
        MyPackagesMaintenancePage: {
            fields: []
        },

        MyPackagesGeneralDataView: {
            fields: []
        },
        MyPackagesGridView: {
            fields: []
        },
        AllJobSearchResultsView: {
            fields: []
        },
        ViewAsPage: {
            fields: []
        },
        RequestAccessPage: {
            fields: []
        },
        FooterView: {
            fields: []
        },
        MemberStatementsPage: {
            fields: []
        },
        MemberPaymentStatementGeneralDataView: {
            fields: []
        },
        MemberStatementDetailsPage: {
            fields: []
        },
        MemberStatementDetailsGridsView: {
            fields: []
        },
        MemberStatementPaymentSummaryGridsView: {
            fields: []
        },
        MemberStatementWorkDetailsGridsView: {
            fields: []
        },
        MemberStatementUsageDetailsPage: {
            fields: []
        },
        MemberStatementWorksPage: {
            fields: []
        },
        UnpaidClaimsMembersPage: {
            fields: []
        },
        MemberStatementUsageDetailsGridsView: {
            fields: []
        },
        LivePerformanceSubmissionPage: {
            fields: []
        },
        SubmitNewLivePerformancePage: {
            fields: []
        },
        LivePerformanceMaintenanceGeneralDataView: {
            fields: []
        },
        LivePerformanceMaintenanceToolbar: {
            fields: []
        },
        LivePerformanceMaintenanceGridsViewData: {
            fields: []
        },
        ClaimsHistoryPage: {
            fields: []
        },
        UnpaidClaimsRegisteredWorksSearch: {
            fields: []
        },
        DraftAgreementsMaintenanceToolbar: {
            fields: []
        },
        DraftAgreementsMaintenanceGridsViewData: {
            fields: []
        },
        TerritorySelectionModalViewData: {
            fields: []
        },
        CommentsModalViewData: {
            fields: []
        },
        MemberStatementAnalyticsPage: {
            fields: []
        }
    },
    downloadFileFormat: {},
    myPackagesResult: [],
    displayRepresentation: false,
    isSearching: false,
    activeTab: 0,
    saveInProgress: false,
    packageOperationInProgress: false,
    searchSuccessful: undefined,
    readonlyFlagsField: [],
    repertoireUsers: [],
    shareSetsShownInPortal: [],
    portalWorkStatusConfiguration: {
        mappings: [],
        excludedBackOfficeStatuses: []
    },
    resultsPerPage: [
        { repertoireSection: 'draftWorks', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'registeredWorks', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'allRegisteredWorks', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'unpaidClaims', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'unpaidClaimsMembers', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'draftAgreements', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'registeredAgreements', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'unpaidClaimsMembersWorkSearch', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'claimsHistory', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'works', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'productWorkSearch', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'products', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'registeredCueSheets', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'draftCueSheets', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'allRegisteredCueSheets', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
    ],
    defaultActiveAccordions: [],
    distributions: [],
    works: [],
    getDraftWorkDetailsError: undefined,
    isFetchingDraftWork: false,
    requestAccessIPSearchResult: [],
    requestingViewAsAccess: false,
    requestViewAsAccessSuccess: undefined,
    viewAsAccessRequests: undefined,
    viewAsAccessSaveSuccess: undefined,
    cancelAccessRequestSuccess: undefined,
    isFetchingDraftSetList: false,
    isFetchingLivePerformance: false,
    shareDecimalsToDisplay: 2,
    isCRMIntegrationEnabled: false,
    powerPortalURL: undefined,
    enableSetTypeBundle: false,
    powerBIEmbedParams: undefined
};

export function showModal(
    modalContent: string,
    modalComponentInstance: string,
    modalProps: any,
    displayModalCloseButton: boolean,
    title: string,
    modalMessage?: string,
    isReadOnly?: boolean,
    key?: string,
    index?: number
): ShowModal {
    return {
        type: SHOW_MODAL,
        payload: {
            modalContent,
            modalProps,
            modalComponentInstance,
            displayModalCloseButton,
            title,
            modalMessage,
            isReadOnly,
            key,
            index
        }
    };
}

export function updateDraftWorkField(value: any, fieldName: IWorkStateKeys, index?: number): UpdateDraftWorkField {
    return {
        type: MP_UPDATE_DRAFT_WORK_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}

export function updateDraftAgreementField(value: any, fieldName: IAgreementStateKeys, index?: number): UpdateDraftAgreementField {
    return {
        type: MP_UPDATE_DRAFT_AGREEMENT_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}
export function updateDraftAgreementWorkField(value: any, fieldName: IAgreementStateKeys, index?: number): UpdateDraftAgreementWorkField {
    return {
        type: MP_UPDATE_DRAFT_AGREEMENT_WORK_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}


export function updateLivePerformanceField(value: any, fieldName: IUsageGroupStateKeys, index?: number): UpdateLivePerformanceField {
    return {
        type: MP_UPDATE_LIVE_PERFORMANCE_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}
export function searchLicenseVenuesRequest(): SearchLicenseVenuesRequest {
    return {
        type: SEARCH_LICENSE_VENUES_REQUEST
    };
}

export function searchLicenseVenuesSuccess(result: ILicenseCustomerVenue[]): SearchLicenseVenuesSuccess {
    return {
        type: MP_SEARCH_LICENSE_VENUES_SUCCESS,
        payload: {
            licenseVenuesResult: result
        }

    };
}

export interface MpAddLicenseVenueToUsage {
    type: typeof MP_ADD_LICENSE_VENUE_TO_USAGE;
    payload: {
        licenseVenue: ILicenseCustomerVenue;
    }
}


export function updateLivePerformanceSetListAdditionalField(value: any, fieldName: IUsageGroupSetListAdditionalStateKeys, index?: number): UpdateLivePerformanceSetListAdditionalField {
    return {
        type: MP_UPDATE_LIVE_PERFORMANCE_SET_LIST_ADDITIONAL_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}
export function updateLivePerformanceVenueDetailsField(value: any, fieldName: IUsageGroupVenueDetailsStateKeys, index?: number): UpdateLivePerformanceVenueDetailsField {
    return {
        type: MP_UPDATE_LIVE_PERFORMANCE_VENUE_DETAILS_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}


export function getSetListWorkDefaultDurationConfigRequest(): GetSetListWorkDefaultDurationRequest {
    return {
        type: GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_REQUEST
    }
}

export function getSetListWorkDefaultDurationConfigSuccess(setListWorksDefaultDuration: number): GetSetListWorkDefaultDurationSuccess {
    return {
        type: GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_SUCCESS,
        payload: {
            setListWorksDefaultDuration
        }
    }
}

export function getSetListWorkDefaultDurationConfigFailure(error: any): GetSetListWorkDefaultDurationFailure {
    return {
        type: GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}



export function updateDraftSetListsField(value: any, fieldName: ISetListsStateKeys, index?: number): UpdateDraftSetListsField {
    return {
        type: MP_UPDATE_DRAFT_SET_LISTS_FIELD,
        payload: {
            value,
            fieldName,
            index
        }
    }
}

export function updateRegisteredWorkField(value: any, fieldName: IWorkStateKeys, lookups?: ILookupDictionary, subFieldName?: string): UpdateRegisteredWorkField {
    return {
        type: MP_UPDATE_REGISTERED_WORK_FIELD,
        payload: {
            value,
            fieldName,
            lookups,
            subFieldName
        }
    }
}

export function getRegisteredWorkDetailsRequest(): GetRegisteredWorkDetailsRequest {
    return {
        type: MP_GET_REGISTERED_WORK_DETAILS_REQUEST
    }
}

export function getRegisteredWorkDetailsSuccess(workDetails: IWork): GetRegisteredWorkDetailsSuccess {
    return {
        type: MP_GET_REGISTERED_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails
        }
    }
}

export function getRegisteredWorkDetailsFailure(error: any, workId: number): GetRegisteredWorkDetailsFailure {
    return {
        type: MP_GET_REGISTERED_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    }
}

export function getRegisteredSetListDetailsRequest(): GetRegisteredSetListDetailsRequest {
    return {
        type: MP_GET_REGISTERED_SET_LIST_DETAILS_REQUEST
    }
}

export function getRegisteredSetListDetailsSuccess(setListDetails: IProductCore): GetRegisteredSetListDetailsSuccess {
    return {
        type: MP_GET_REGISTERED_SET_LIST_DETAILS_SUCCESS,
        payload: {
            setListDetails
        }
    }
}

export function getRegisteredSetListDetailsFailure(error: any, productCoreId: number): GetRegisteredSetListDetailsFailure {
    return {
        type: MP_GET_REGISTERED_SET_LIST_DETAILS_FAILURE,
        payload: {
            error,
            productCoreId
        }
    }
}
export function getAllRegisteredWorkDetailsRequest(): GetAllRegisteredWorkDetailsRequest {
    return {
        type: MP_GET_ALL_REGISTERED_WORK_DETAILS_REQUEST
    }
}

export function getFullCataloguePackagePendingSuccess(result: IMyPackagesDetails[]): GetFullCataloguePackagePendingSuccess {
    return {
        type: MP_GET_FULL_CATALOGUE_PACKAGE_PENDING_SUCCESS,
        payload: {
            myPackagesDetails: result
        }
    };
}

export function getFullCataloguePackagePendingFailure(error: string, userName: string): GetFullCataloguePackagePendingFailure {
    return {
        type: MP_GET_FULL_CATALOGUE_PACKAGE_PENDING_FAILURE,
        payload: {
            error,
            userName
        }
    };
}
export function createPackageFromCriteriaRequest(): CreatePackageFromCriteriaRequest {
    return {
        type: MP_CREATE_PACKAGE_FROM_CRITERIA_REQUEST,
    };
}

export function createPackageFromCriteriaSuccess(result: IAddtoPackageResult): CreatePackageFromCriteriaSuccess {
    return {
        type: MP_CREATE_PACKAGE_FROM_CRITERIA_SUCCESS,
        payload: { result }
    };
}

export function createPackageFromCriteriaFailure(result: IAddtoPackageResult): CreatePackageFromCriteriaFailure {
    return {
        type: MP_CREATE_PACKAGE_FROM_CRITERIA_FAILURE,
        payload: { result }
    };
}

export function getAssigneeAgreementsRequest(): GetAssigneeAgreementsRequest {
    return {
        type: MP_GET_ASSIGNEE_AGREEMENTS_REQUEST
    }
}

export function getAssigneeAgreementsSuccess(assigneeAgreementsResult: IAssigneeAgreementResult[]): GetAssigneeAgreementsSuccess {
    return {
        type: MP_GET_ASSIGNEE_AGREEMENTS_SUCCESS,
        payload: {
            assigneeAgreementsResult
        }
    }
}

export function getAssigneeAgreementsFailure(error: string): GetAssigneeAgreementsFailure {
    return {
        type: MP_GET_ASSIGNEE_AGREEMENTS_FAILURE,
        payload: {
            error
        }
    };
}

export function getAllRegisteredWorkDetailsSuccess(workDetails: IWork): GetAllRegisteredWorkDetailsSuccess {
    return {
        type: MP_GET_ALL_REGISTERED_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails
        }
    }
}

export function getAllRegisteredWorkDetailsFailure(error: any, workId: number): GetAllRegisteredWorkDetailsFailure {
    return {
        type: MP_GET_ALL_REGISTERED_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    }
}

export function incrementTempID(): IncrementTempID {
    return {
        type: MP_INCREMENT_TEMPID
    };
}

function filterValidContributors(workToCopy: IWorkState, lookups: ILookupDictionary): Dictionary<IContributorItem[]> {
    if (!workToCopy?.contributors) return {};

    const filteredLookupValues =
        lookups && typeof lookups === "object"
            ? Object.fromEntries(
                Object.entries(lookups).map(([key, value]) => [
                    key,
                    value && Array.isArray(value.lookups)
                        ? {
                            ...value,
                            lookups: value.lookups.filter(
                                (it) =>
                                    !(
                                        (it as any)?.extraFields?.DisplayOnPortal === false ||
                                        (it as any)?.extraFields?.IsDisplayedInPortal === false
                                    )
                            ),
                        }
                        : value,
                ])
            )
            : lookups;

    const validRoleCodes = new Set((filteredLookupValues?.WorkContributorType?.lookups ?? []).map((l: any) => String(l.code ?? "")));

    const validSocietyCodes = new Set((filteredLookupValues?.WorkSocietyOfLicense?.lookups ?? []).map((l: any) => String(l.code ?? "")));

    const filtered: Dictionary<IContributorItem[]> = {};

    for (const [key, items] of Object.entries(workToCopy.contributors)) {
        const arr = Array.isArray(items) ? items : [];
        filtered[key] = arr.filter((c) =>
            ((c.role?.value ?? "") === "" || validRoleCodes.has(c.role?.value ?? "")) &&
            ((c.societyOfLicense?.value ?? "") === "" || validSocietyCodes.has(c.societyOfLicense?.value ?? ""))
        );
    }

    return filtered;
}

function resetDraftWorkIds(work: IWorkState, lookupValues: ILookupDictionary, userName?: string) {
    const max: number = 99999999;
    work.workID = 0;
    work.versionNumber = 0
    work.workBatchID = null;
    work.workBatch = null;
    work.workCreationDate = new Date().toISOString();
    work.lastModifiedDate = new Date().toISOString();
    work.source = "MEMBER";
    work.concurrency = null;
    work.isReplaced = false;
    work.artists.forEach(function (child) {
        child.performerID = 0 - child.performerID - Math.floor(Math.random() * max);
        child.workPerformerID = 0 - child.workPerformerID - Math.floor(Math.random() * max);
    });
    const flattenedContributors = WorkDetailsMapper.flattenContributors(work.contributors);
    flattenedContributors.forEach(function (child) {
        const previousID = child.workContributorID
        child.workContributorID = 0 - child.workContributorID - Math.floor(Math.random() * max);
        flattenedContributors.forEach(function (other) {
            if (other.relationshipIDs != null && other.relationshipIDs.length > 0) {
                if (other.relationshipIDs.includes(previousID)) {
                    other.relationshipIDs = other.relationshipIDs.filter(x => x !== previousID);
                    other.relationshipIDs.push(child.workContributorID)
                }
            }
        });
    });
    for (var key in work.contributors) {
        work.contributors[key] = [];
    }
    flattenedContributors.forEach(function (child) {
        work.contributors[child.setType].push(child);
    })
    work.numbers.forEach(function (child) {
        child.workNumberID = 0 - child.workNumberID - Math.floor(Math.random() * max);
    });
    work.territorySpecificInfo.workTerritorySpecificInfo.forEach(function (child) {
        child.workTerritorySpecificInfoID = 0 - child.workTerritorySpecificInfoID - Math.floor(Math.random() * max);
    });
    work.titles.forEach(function (child) {
        child.workNameID = 0 - child.workNameID - Math.floor(Math.random() * max);
    });
    work.workContributorSetTypes.forEach(function (child) {
        child.workContributorSetTypeID = 0 - child.workContributorSetTypeID - Math.floor(Math.random() * max);
    });

    work.instrumentation.forEach(function (child) {
        child.instrumentationID = 0 - child.instrumentationID - Math.floor(Math.random() * max);
    });

    work.registrationDate = (new Date()).toISOString();

    work.comments.forEach(function (child) {
        child.notesID = 0 - child.notesID - Math.floor(Math.random() * max);
        child.user = { value: userName, inputType: '' }
    })

    work.territorySpecificInfo.workTerritorySpecificInfo.forEach((w) => {
        w.workStatus = "DRAFT";
        w.workSubStatus = null;
    });

    if ((work.workPrice !== undefined || work.workPrice !== null) && (work.workPrice.length > 0)) {
        work.workPrice.forEach((w) => {
            w.workPriceID = 0 - w.workPriceID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.otherIndicators !== undefined || work.otherIndicators !== null) && (work.otherIndicators.length > 0)) {
        work.otherIndicators.forEach((w) => {
            w.flagID = 0 - w.flagID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.readonlyIndicators !== undefined || work.readonlyIndicators !== null) && (work.readonlyIndicators.length > 0)) {
        work.readonlyIndicators.forEach((w) => {
            w.flagID = 0 - w.flagID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.subjects !== undefined || work.subjects !== null) && (work.subjects.length > 0)) {
        work.subjects.forEach((w) => {
            w.SubjectID = 0 - w.SubjectID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if (work.bookMetadata !== undefined || work.bookMetadata !== null) {
        work.bookMetadata.workMetadataID = 0 - work.bookMetadata.workMetadataID - Math.floor(Math.random() * max);
        work.bookMetadata.workMetadataBookID = 0 - work.bookMetadata.workMetadataBookID - Math.floor(Math.random() * max);
    }
    if (work.articleMetadata !== undefined || work.articleMetadata !== null) {
        work.articleMetadata.workMetadataArticleID = 0 - work.articleMetadata.workMetadataArticleID - Math.floor(Math.random() * max);
        work.articleMetadata.workMetadataID = 0 - work.articleMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if (work.chapterMetadata !== undefined || work.chapterMetadata !== null) {
        work.chapterMetadata.workMetadataChapterID = 0 - work.chapterMetadata.workMetadataChapterID - Math.floor(Math.random() * max);
        work.chapterMetadata.workMetadataID = 0 - work.chapterMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if (work.magazineMetadata !== undefined || work.magazineMetadata !== null) {
        work.magazineMetadata.workMetadataPublicationID = 0 - work.magazineMetadata.workMetadataPublicationID - Math.floor(Math.random() * max);
        work.magazineMetadata.workMetadataID = 0 - work.magazineMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if ((work.magazineLevyCopyCriterias !== undefined || work.magazineLevyCopyCriterias !== null) && (work.magazineLevyCopyCriterias.length > 0)) {
        work.magazineLevyCopyCriterias.forEach((w) => {
            w.workMetadataMagazineLevyCopyCriteriaID.value = 0 - w.workMetadataMagazineLevyCopyCriteriaID.value - Math.floor(Math.random() * max);
            w.workID.value = work.workID;
        });
    }
    if (work.sheetMusicMetadata !== undefined || work.sheetMusicMetadata !== null) {
        work.sheetMusicMetadata.workMetadataSheetMusicID = 0 - work.sheetMusicMetadata.workMetadataSheetMusicID - Math.floor(Math.random() * max);
        work.sheetMusicMetadata.workMetadataID = 0 - work.sheetMusicMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    work.replacedWorks = []
}

function resetDraftSetListIds(setList: IProductState, lookupValues: ILookupDictionary, userName?: string) {
    const max: number = 99999999;
    setList.productCoreID = 0;
    setList.id1 = null;
    setList.id2 = null;
    setList.productBatchID = null;

    setList.productName.forEach(function (child) {
        child.productNameID = 0 - child.productNameID - Math.floor(Math.random() * max);
    });

    setList.productNumber.forEach(function (child) {
        child.productNumberID = 0 - child.productNumberID - Math.floor(Math.random() * max);
    });

    setList.productPerformer.forEach(function (child) {
        child.productPerformerID = 0 - child.productPerformerID - Math.floor(Math.random() * max);
    });

    setList.productWork.forEach(function (child) {
        child.productWorkID = 0 - child.productWorkID - Math.floor(Math.random() * max);
    });

    if (setList.productAVWork) {
        setList.productAVWork.productAVWorkID = 0;
        setList.productAVWork.productCoreID = 0;
    }

    if (setList.productSourceIP) {
        setList.productSourceIP.sourceIPID = 0;
    }

    setList.productAVRequest = null;
    setList.productAVWorkSubmissions = [];

    setList.productContributor.forEach(function (child) {
        child.productContributorID = 0 - child.productContributorID - Math.floor(Math.random() * max);
    });

    setList.comments = [];

}


function resetRegisteredWorkIds(registeredWork: IWorkState) {
    const max: number = 99999999;
    registeredWork.workID = 0 - new Date().getTime();
}

export function createNewDraftWork(lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, draftWorkMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]): CreateNewDraftWork {
    return {
        type: MP_CREATE_NEW_DRAFT_WORK,
        payload: {
            lookups,
            isNew,
            draftWorkMaintenanceGeneralDataViewData,
            formats,
            currentUserNameNumber,
            tabId: uuidv4()
        }
    };
}

export function createNewDraftAgreement(lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, draftAgreementMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]): CreateNewDraftAgreement {
    return {
        type: MP_CREATE_NEW_DRAFT_AGREEMENT,
        payload: {
            lookups,
            isNew,
            draftAgreementMaintenanceGeneralDataViewData,
            formats,
            currentUserNameNumber,
            tabId: uuidv4()
        }
    };
}

export function createNewDraftSetLists(lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, draftSetListsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]): CreateNewDraftSetLists {
    return {
        type: MP_CREATE_NEW_DRAFT_SET_LISTS,
        payload: {
            lookups,
            isNew,
            draftSetListsMaintenanceGeneralDataViewData,
            formats,
            currentUserNameNumber,
            tabId: uuidv4()
        }
    };
}

export function saveContributorComment(contributorID: number, comments: string): SaveContributorComment {
    return {
        type: MP_SAVE_WORK_CONTRIBUTOR_COMMENT,
        payload: {
            contributorID,
            comments
        }
    }
}

export function uploadCueSheetsFiles(inputFiles?: IStoragePathItemData[], errorsFiles?: IStoragePathItemData[], archiveFiles?: IStoragePathItemData[], formats?: FormatFields[], currentUserNameNumber?: string): UploadCueSheetsRequest {
    return {
        type: MP_UPLOAD_CUE_FILES_SHEETS,
        payload: {
            inputFiles,
            errorsFiles,
            archiveFiles,
            formats,
            currentUserNameNumber,
            tabId: uuidv4()
        }
    };
}

export function createNewDraftLivePerformance(lookups: ILookupDictionary, isNew?: boolean, livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[], distributionCode?: string, currentUserNameNumber?: string): CreateNewDraftLivePerformance {
    return {
        type: MP_CREATE_NEW_LIVE_PERFORMANCE,
        payload: {
            lookups,
            isNew,
            livePerformanceMaintenanceGeneralDataViewData,
            formats,
            distributionCode,
            currentUserNameNumber,
            tabId: uuidv4()
        }
    };
}

export function createNewRegisteredWork(lookups: ILookupDictionary, isNew?: boolean, registeredWorkMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem): CreateNewRegisteredWork {
    return {
        type: MP_CREATE_NEW_REGISTERED_WORK,
        payload: {
            lookups,
            isNew,
            registeredWorkMaintenanceGeneralDataViewData
        }
    };
}

export function copyExistingDraftWork(actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary): CopyExistingDraftWork {
    return {
        type: MP_COPY_DRAFT_WORK,
        payload: {
            actionList,
            userName,
            lookups

        }
    };
}
export function copyExistingDraftLivePerformance(actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary): CopyExistingDraftLivePerformance {
    return {
        type: MP_COPY_DRAFT_LIVE_PERFORMANCE,
        payload: {
            actionList,
            userName,
            lookups

        }
    };
}
export function copyExistingDraftSetList(actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary): CopyExistingDraftSetList {
    return {
        type: MP_COPY_DRAFT_SET_LIST,
        payload: {
            actionList,
            userName,
            lookups

        }
    };
}



export function copyExistingRegisteredWork(actionList: IDataActionToolbar[]): CopyExistingRegisteredWork {
    return {
        type: MP_COPY_REGISTERED_WORK,
        actionList
    };
}

export function undoDraftWorkChangesRequest(): UndoDraftWorkChangesRequest {
    return {
        type: MP_UNDO_DRAFT_WORK_CHANGES_REQUEST
    }
}

export function undoDraftWorkChangesSuccess(work: IWork, lookupValues: ILookupDictionary): UndoDraftWorkChangesSuccess {
    return {
        type: MP_UNDO_DRAFT_WORK_CHANGES_SUCCESS,
        payload: {
            work,
            lookupValues
        }
    }
}

export function undoDraftWorkChangesFailure(error: any): UndoDraftWorkChangesFailure {
    return {
        type: MP_UNDO_DRAFT_WORK_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}


export function undoDraftSetListChangesRequest(): UndoDraftSetListChangesRequest {
    return {
        type: MP_UNDO_DRAFT_SET_LIST_CHANGES_REQUEST,
    }
}

export function undoDraftSetListChangesSuccess(product: IProductCore, lookupValues: ILookupDictionary): UndoDraftSetListChangesSuccess {
    return {
        type: MP_UNDO_DRAFT_SET_LIST_CHANGES_SUCCESS,
        payload: {
            product,
            lookupValues
        }
    }
}

export function undoDraftSetListChangesFailure(error: any): UndoDraftSetListChangesFailure {
    return {
        type: MP_UNDO_DRAFT_SET_LIST_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function undoRegisteredWorkChangesRequest(): UndoRegisteredWorkChangesRequest {
    return {
        type: MP_UNDO_REGISTERED_WORK_CHANGES_REQUEST
    }
}

export function undoRegisteredWorkChangesSuccess(registeredWork: IWork, lookupValues: ILookupDictionary): UndoRegisteredWorkChangesSuccess {
    return {
        type: MP_UNDO_REGISTERED_WORK_CHANGES_SUCCESS,
        payload: {
            registeredWork,
            lookupValues
        }
    }
}

export function undoRegisteredWorkChangesFailure(error: any): UndoRegisteredWorkChangesFailure {
    return {
        type: MP_UNDO_REGISTERED_WORK_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}


export function searchDraftWorkVersionHistoryRequest(): SearchDraftWorkVersionHistoryRequest {
    return {
        type: MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_REQUEST
    };
}

export function searchDraftWorkVersionHistorySuccess(results: IDraftWorkVersionHistorySearchResult[]): SearchDraftWorkVersionHistorySuccess {
    return {
        type: MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchDraftWorkVersionHistoryFailure(): SearchDraftWorkVersionHistoryFailure {
    return {
        type: MP_SEARCH_DRAFT_WORK_VERSION_HISTORY_FAILURE
    };
}


export function searchDraftWorksRequest(isModalSearch?: boolean): SearchDraftWorksRequest {
    return {
        type: MP_SEARCH_DRAFT_WORKS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchDraftWorksSuccess(draftWorksResult: IDraftWorkSearchResult[]): SearchDraftWorksSuccess {
    return {
        type: MP_SEARCH_DRAFT_WORKS_SUCCESS,
        payload: {
            draftWorksResult
        }
    }
}

export function searchDraftWorksFailure(error: string): SearchDraftWorksFailure {
    return {
        type: MP_SEARCH_DRAFT_WORKS_FAILURE,
        payload: {
            error
        }
    };
}


export function searchDraftAgreementsRequest(isModalSearch?: boolean): SearchDraftAgreementsRequest {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchDraftAgreementsIPRequest(isModalSearch?: boolean): SearchDraftAgreementsIPRequest {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_IP_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchDraftAgreementsWorksRequest(isModalSearch?: boolean): SearchDraftAgreementsWorksRequest {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_WORKS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}




export function searchDraftAgreementsSuccess(draftAgreementsResult: IDraftAgreementSearchResult[]): SearchDraftAgreementsSuccess {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_SUCCESS,
        payload: {
            draftAgreementsResult
        }
    }
}

export function searchDraftAgreementsIPSuccess(draftAgreementsIPResult: IIPsSearchResult[]): SearchDraftAgreementsIPSuccess {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_IP_SUCCESS,
        payload: {
            draftAgreementsIPResult
        }
    }
}

export function searchDraftAgreementsWorksSuccess(draftAgreementsWorksResult: IWorksSearchResult[]): SearchDraftAgreementsWorksSuccess {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_WORKS_SUCCESS,
        payload: {
            draftAgreementsWorksResult
        }
    }
}



export function searchDraftAgreementsFailure(error: string): SearchDraftAgreementsFailure {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_FAILURE,
        payload: {
            error
        }
    };
}
export function searchDraftAgreementsIPFailure(error: string): SearchDraftAgreementsIPFailure {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_IP_FAILURE,
        payload: {
            error
        }
    };
}

export function searchDraftAgreementsWorksFailure(error: string): SearchDraftAgreementsWorksFailure {
    return {
        type: MP_SEARCH_DRAFT_AGREEMENTS_WORKS_FAILURE,
        payload: {
            error
        }
    };
}


export function searchRegisteredAgreementsRequest(isModalSearch?: boolean): SearchRegisteredAgreementsRequest {
    return {
        type: MP_SEARCH_REGISTERED_AGREEMENTS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchRegisteredAgreementsSuccess(registeredAgreementsResult: IRegisteredAgreementSearchResult[]): SearchRegisteredAgreementsSuccess {
    return {
        type: MP_SEARCH_REGISTERED_AGREEMENTS_SUCCESS,
        payload: {
            registeredAgreementsResult
        }
    }
}

export function searchRegisteredAgreementsFailure(error: string): SearchRegisteredAgreementsFailure {
    return {
        type: MP_SEARCH_REGISTERED_AGREEMENTS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchDraftSetListsRequest(): SearchDraftSetListsRequest {
    return {
        type: MP_SEARCH_DRAFT_SET_LISTS_REQUEST
    };
}

export function searchDraftSetListsSuccess(setListsResult: IDraftSetListSearchResult[]): SearchDraftSetListsSuccess {
    return {
        type: MP_SEARCH_DRAFT_SET_LISTS_SUCCESS,
        payload: {
            setListsResult
        }
    }
}

export function searchDraftSetListsFailure(error: string): SearchDraftSetListsFailure {
    return {
        type: MP_SEARCH_DRAFT_SET_LISTS_FAILURE,
        payload: {
            error
        }
    };
}

export function getDraftWorkDetailsRequest(): GetDraftWorkDetailsRequest {
    return {
        type: MP_GET_DRAFT_WORK_DETAILS_REQUEST
    }
}


export function getDraftWorkDetailsSuccess(workDetails: IWork): GetDraftWorkDetailsSuccess {
    return {
        type: MP_GET_DRAFT_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails
        }
    }
}

export function getDraftWorkDetailsFailure(error: any, workId: number): GetDraftWorkDetailsFailure {
    return {
        type: MP_GET_DRAFT_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    }
}

export function getDraftAgreementDetailsRequest(): GetDraftAgreementDetailsRequest {
    return {
        type: MP_GET_DRAFT_AGREEMENT_DETAILS_REQUEST
    }
}

export function getDraftAgreementDetailsSuccess(agreementDetails: IAgreement): GetDraftAgreementDetailsSuccess {
    return {
        type: MP_GET_DRAFT_AGREEMENT_DETAILS_SUCCESS,
        payload: {
            agreementDetails
        }
    }
}

export function getDraftAgreementDetailsFailure(error: any, agreementId: number): GetDraftAgreementDetailsFailure {
    return {
        type: MP_GET_DRAFT_AGREEMENT_DETAILS_FAILURE,
        payload: {
            error,
            agreementId
        }
    }
}

export function getDraftSetListDetailsRequest(): GetDraftSetListDetailsRequest {
    return {
        type: MP_GET_DRAFT_SET_LIST_DETAILS_REQUEST
    }
}

export function getCueSheetsDetailsRequest(): GetCueSheetsDetailsRequest {
    return {
        type: MP_GET_CUE_SHEET_DETAILS_REQUEST
    }
}

export function getCueSheetsDetailsSuccess(cueSheetDetails: IProductCore): GetCueSheetsDetailsSuccess {
    return {
        type: MP_GET_CUE_SHEET_DETAILS_SUCCESS,
        payload: {
            cueSheetDetails
        }
    }
}

export function searchLicensVenuesFailure(error: string): SearchLicenseVenuesFailure {
    return {
        type: MP_SEARCH_LICENSE_VENUES_FAILURE,
        payload: {
            error
        }
    };
}

export function addLicenseVenueToUsage(licenseVenue: ILicenseCustomerVenue): MpAddLicenseVenueToUsage {
    return {
        type: MP_ADD_LICENSE_VENUE_TO_USAGE,
        payload: {
            licenseVenue,
        }
    }
}

export function getCueSheetsDetailsFailure(error: any, productCoreId: number): GetCueSheetsDetailsFailure {
    return {
        type: MP_GET_CUE_SHEET_DETAILS_FAILURE,
        payload: {
            error,
            productCoreId
        }
    }
}

export function getDraftSetListDetailsSuccess(setListDetails: IProductCore): GetDraftSetListDetailsSuccess {
    return {
        type: MP_GET_DRAFT_SET_LIST_DETAILS_SUCCESS,
        payload: {
            setListDetails
        }
    }
}

export function getDraftSetListDetailsFailure(error: any, productCoreId: number): GetDraftSetListDetailsFailure {
    return {
        type: MP_GET_DRAFT_SET_LIST_DETAILS_FAILURE,
        payload: {
            error,
            productCoreId
        }
    }
}

export function getDraftWorkIDsRequest(): GetDraftWorkIDsRequest {
    return {
        type: MP_GET_DRAFT_WORK_ID_REQUEST
    };
}

export function getDraftWorkIDsSuccess(result: any): GetDraftWorkIDsSuccess {
    return {
        type: MP_GET_DRAFT_WORK_ID_SUCCESS,
        payload: {
            workIDs: result
        }
    };
}

export function getDraftWorkIDsFailure(error: string): GetDraftWorkIDsFailure {
    return {
        type: MP_GET_DRAFT_WORK_ID_FAILURE,
        payload: {
            error
        }
    };
}


export function saveDraftWorkRequest(): SaveDraftWorkRequest {
    return {
        type: MP_SAVE_DRAFT_WORK_REQUEST
    }
}

export function saveDraftWorkSuccess(workSaveResult: IWorkSaveResult, lookupValues: ILookupDictionary): SaveDraftWorkSuccess {
    return {
        type: MP_SAVE_DRAFT_WORK_SUCCESS,
        payload: {
            workSaveResult,
            lookupValues
        }
    }
}

export function saveDraftWorkFailure(workSaveResult: IWorkSaveResult, lookupValues: ILookupDictionary): SaveDraftWorkFailure {
    return {
        type: MP_SAVE_DRAFT_WORK_FAILURE,
        payload: {
            workSaveResult,
            lookupValues
        }
    }
}

export function saveDraftSetListsRequest(): SaveDraftSetListsRequest {
    return {
        type: MP_SAVE_DRAFT_SET_LISTS_REQUEST
    }
}

export function saveDraftAgreementRequest(): SaveDraftAgreementRequest {
    return {
        type: MP_SAVE_DRAFT_AGREEMENT_REQUEST
    }
}

export function saveDraftSetListSuccess(setListsSaveResult: IProductSaveResult): SaveDraftSetListsSuccess {
    return {
        type: MP_SAVE_DRAFT_SET_LISTS_SUCCESS,
        payload: {
            setListsSaveResult
        }
    }
}

export function saveDraftAgreementSuccess(agreementSaveResult: IAgreementSaveResult, resetChangesMade): SaveDraftAgreementSuccess {
    return {
        type: MP_SAVE_DRAFT_AGREEMENT_SUCCESS,
        payload: {
            agreementSaveResult,
            resetChangesMade
        }
    }
}

export function saveDraftAgreementFailure(agreementSaveResult: IAgreementSaveResult): SaveDraftAgreementFailure {
    return {
        type: MP_SAVE_DRAFT_AGREEMENT_FAILURE,
        payload: {
            agreementSaveResult
        }
    }
}

export function saveDraftLivePerformanceSuccess(usageSaveResult: IUsageSaveResult): SaveDraftLivePerformanceSuccess {
    return {
        type: MP_SAVE_DRAFT_LIVE_PERFORMANCE_SUCCESS,
        payload: {
            usageSaveResult
        }
    }
}

export function saveDraftSetListsFailure(setListsSaveResult: IProductSaveResult): SaveDraftSetListsFailure {
    return {
        type: MP_SAVE_DRAFT_SET_LISTS_FAILURE,
        payload: {
            setListsSaveResult
        }
    }
}

export function saveDraftLivePerformanceFailure(usageSaveResult: IUsageSaveResult): SaveDraftLivePerformanceFailure {
    return {
        type: MP_SAVE_DRAFT_LIVE_PERFORMANCE_FAILURE,
        payload: {
            usageSaveResult
        }
    }
}



export function deleteDraftWorkRequest(): DeleteDraftWorkRequest {
    return {
        type: MP_DELETE_DRAFT_WORK_REQUEST
    }
}

export function deleteDraftWorkSuccess(workId: number): DeleteDraftWorkSuccess {
    return {
        type: MP_DELETE_DRAFT_WORK_SUCCESS,
        payload: {
            workId
        }
    }
}

export function deleteDraftWorkFailure(error?: IValidationMessage): DeleteDraftWorkFailure {
    return {
        type: MP_DELETE_DRAFT_WORK_FAILURE,
        payload: {
            error
        }
    }
}

export function deleteDraftSetListRequest(): DeleteDraftSetListRequest {
    return {
        type: MP_DELETE_DRAFT_SET_LIST_REQUEST
    }
}

export function deleteDraftSetListSuccess(workId: number): DeleteDraftSetListSuccess {
    return {
        type: MP_DELETE_DRAFT_SET_LIST_SUCCESS,
        payload: {
            workId
        }
    }
}

export function deleteDraftSetListFailure(error?: IValidationMessage): DeleteDraftSetListFailure {
    return {
        type: MP_DELETE_DRAFT_SET_LIST_FAILURE,
        payload: {
            error
        }
    }
}

export function searchRegisteredWorksRequest(isModalSearch?: boolean): SearchRegisteredWorksRequest {
    return {
        type: MP_SEARCH_REGISTERED_WORKS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchRegisteredWorksSuccess(registeredWorksResult: IRegisteredWorkSearchResult[]): SearchRegisteredWorksSuccess {
    return {
        type: MP_SEARCH_REGISTERED_WORKS_SUCCESS,
        payload: {
            registeredWorksResult
        }
    }
}

export function searchRegisteredWorksFailure(error: string): SearchRegisteredWorksFailure {
    return {
        type: MP_SEARCH_REGISTERED_WORKS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchCueSheetsRequest(): SearchCueSheetsRequest {
    return {
        type: MP_SEARCH_CUE_SHEETS_REQUEST
    };
}

export function searchCueSheetsSuccess(cueSheetsResult: ICueSheetsSearchResult[]): SearchCueSheetsSuccess {
    return {
        type: MP_SEARCH_CUE_SHEETS_SUCCESS,
        payload: {
            cueSheetsResult
        }
    }
}

export function searchCueSheetsFailure(error: string): SearchCueSheetsFailure {
    return {
        type: MP_SEARCH_CUE_SHEETS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchRegisteredSetListsRequest(): SearchRegisteredSetListsRequest {
    return {
        type: MP_SEARCH_REGISTERED_SET_LISTS_REQUEST
    };
}

export function searchRegisteredSetListsSuccess(registeredSetListsResult: IRegisteredSetListsSearchResults[]): SearchRegisteredSetListsSuccess {
    return {
        type: MP_SEARCH_REGISTERED_SET_LISTS_SUCCESS,
        payload: {
            registeredSetListsResult
        }
    }
}

export function searchRegisteredSetListsFailure(error: string): SearchRegisteredSetListsFailure {
    return {
        type: MP_SEARCH_REGISTERED_SET_LISTS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchAllRegisteredWorksRequest(isModalSearch?: boolean): SearchAllRegisteredWorksRequest {
    return {
        type: MP_SEARCH_ALL_REGISTERED_WORKS_REQUEST,
        payload: {
            isModalSearch
        }
    };
}

export function searchAllRegisteredWorksSuccess(allRegisteredWorksResult: IAllRegisteredWorkSearchResult[]): SearchAllRegisteredWorksSuccess {
    return {
        type: MP_SEARCH_ALL_REGISTERED_WORKS_SUCCESS,
        payload: {
            allRegisteredWorksResult
        }
    }
}

export function searchAllRegisteredWorksFailure(error: string): SearchAllRegisteredWorksFailure {
    return {
        type: MP_SEARCH_ALL_REGISTERED_WORKS_FAILURE,
        payload: {
            error
        }
    };
}

export function getRegisteredWorkRequest(): GetRegisteredWorkRequest {
    return {
        type: MP_GET_REGISTERED_WORK_REQUEST
    }
}

export function getRegisteredWorkSuccess(registeredWork: IRegisteredWork): GetRegisteredWorkSuccess {
    return {
        type: MP_GET_REGISTERED_WORK_SUCCESS,
        payload: {
            registeredWork
        }
    }
}

export function getRegisteredWorkFailure(error: any): GetRegisteredWorkFailure {
    return {
        type: MP_GET_REGISTERED_WORK_FAILURE,
        payload: {
            error
        }
    }
}

export function getRegisteredWorkIDsRequest(): GetRegisteredWorkIDsRequest {
    return {
        type: MP_GET_REGISTERED_WORK_ID_REQUEST
    };
}

export function getRegisteredWorkIDsSuccess(result: any): GetRegisteredWorkIDsSuccess {
    return {
        type: MP_GET_REGISTERED_WORK_ID_SUCCESS,
        payload: {
            workIDs: result
        }
    };
}

export function getRegisteredWorkIDsFailure(error: string): GetRegisteredWorkIDsFailure {
    return {
        type: MP_GET_REGISTERED_WORK_ID_FAILURE,
        payload: {
            error
        }
    };
}


export function saveRegisteredWorkRequest(): SaveRegisteredWorkRequest {
    return {
        type: MP_SAVE_REGISTERED_WORK_REQUEST
    }
}

export function saveRegisteredWorkSuccess(registeredWorkSaveResult: IWorkSaveResult, lookupValues: ILookupDictionary): SaveRegisteredWorkSuccess {
    return {
        type: MP_SAVE_REGISTERED_WORK_SUCCESS,
        payload: {
            registeredWorkSaveResult,
            lookupValues
        }
    }
}

export function saveRegisteredWorkFailure(registeredWorkSaveResult: IWorkSaveResult, lookupValues: ILookupDictionary): SaveRegisteredWorkFailure {
    return {
        type: MP_SAVE_REGISTERED_WORK_FAILURE,
        payload: {
            registeredWorkSaveResult,
            lookupValues
        }
    }
}


export function deleteRegisteredWorkRequest(): DeleteRegisteredWorkRequest {
    return {
        type: MP_DELETE_REGISTERED_WORK_REQUEST
    }
}

export function deleteRegisteredWorkSuccess(workId: number): DeleteRegisteredWorkSuccess {
    return {
        type: MP_DELETE_REGISTERED_WORK_SUCCESS,
        payload: {
            workId
        }
    }
}

export function deleteRegisteredWorkFailure(error?: IValidationMessage): DeleteRegisteredWorkFailure {
    return {
        type: MP_DELETE_REGISTERED_WORK_FAILURE,
        payload: {
            error
        }
    }
}

function getTabTitle(tab: ITabReduxItem): string {
    if (!tab)
        return null;
    if (tab.draftWorkMaintenanceState && tab.draftWorkMaintenanceState.work) {
        const draftWork = tab.draftWorkMaintenanceState.work;
        var tabTitle = draftWork.titles && draftWork.titles.length > 0 ? WorkDetailsMapper.getOriginalTitleFromTitles(draftWork.workID, draftWork.titles) : 'New Draft Work';
        return tabTitle;
    }

    return tab.title;
}

export function resetMessageBanner(): ResetMessageBanner {
    return {
        type: MP_RESET_MESSAGE_BANNER
    }
}

export function mp_addTab(tab: ITabReduxItem, keepTitle?: boolean): AddTabAction {
    return {
        type: MP_ADD_TAB,
        payload: {
            tab: {
                ...tab,
                tabId: tab.tabId ?? uuidv4()
            },
            keepTitle
        }
    };
}
export function mp_replaceTab(tab: ITabReduxItem, targetTabTitle: string): ReplaceTabAction {
    return {
        type: MP_REPLACE_TAB,
        payload: {
            tab,
            targetTabTitle
        }
    }
}
export function mp_removeTab(index: number): RemoveTabAction {
    return {
        type: MP_REMOVE_TAB,
        payload: {
            index
        }
    };
}

export function mp_openTab(index: number): OpenTabAction {
    return {
        type: MP_OPEN_TAB,
        payload: {
            index
        }
    };
}

export function getDefaultUseRelationshipflagSuccess(useRelationshipflag: boolean): GetDefaultUseRelationshipFlag {
    return {
        type: MP_DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS,
        payload: {
            useRelationshipflag
        }
    }
}

export function getDefaultIsAppliedAtIPNameNumberLevelflagSuccess(isAppliedAtIPNameNumberLevelflag: boolean): GetDefaultIsAppliedAtIPNameNumberLevelflag {
    return {
        type: MP_DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS,
        payload: {
            isAppliedAtIPNameNumberLevelflag
        }
    }
}

export function getSubmitterMustBeAssociatedWithAgreementSuccess(submitterMustBeAssociatedWithAgreement: boolean): GetSubmitterMustBeAssociatedWithAgreementFlag {
    return {
        type: MP_SUBMITTER_MUST_BE_ASSOCIATED_FLAG_SUCCESS,
        payload: {
            submitterMustBeAssociatedWithAgreement
        }
    }
}

export function mp_setChangesMade(tabIndex: number | null, changesMade: boolean): SetChangesMade {
    return {
        type: MP_SET_CHANGES_MADE,
        payload: {
            tabIndex,
            changesMade
        }
    };
}

export function clearModalSearchResults(): ClearModalSearchResults {
    return {
        type: MP_CLEAR_MODAL_SEARCH_RESULTS
    }
}

export function openAccordion(
    accordionName: string,
    componentName: string
): OpenAccordion {
    return {
        type: MP_OPEN_ACCORDION,
        payload: {
            accordionName,
            componentName
        }
    };
}

export function closeAccordion(
    accordianName: string,
    componentName: string
): CloseWorkMaintenanceAccordian {
    return {
        type: MP_CLOSE_ACCORDION,
        payload: {
            accordionName: accordianName,
            componentName: componentName
        }
    };
}

export function setDataSource(dataSource: string): SetDataSourceAction {
    return {
        type: SET_DATA_SOURCE,
        payload: {
            dataSource
        }
    };
}


export function setEditableFields(componentFieldName: string, componentInstance: string): SetEditableFields {
    return {
        type: MP_SET_EDITABLE_FIELDS_TAB,
        payload: {
            componentFieldName,
            componentInstance
        }
    }
}

export function updateEditableFields(value: any[]): UpdateEditableField {
    return {
        type: MP_UPDATE_EDITABLE_FIELD,
        payload: {
            value
        }
    }
}

export function updateFieldComponentRequest(): UpdateComponentFieldRequest {
    return {
        type: MP_UPDATE_COMPONENT_FIELD_REQUEST
    };
}

export function updateFieldComponentRequestSuccess(componentFields: IMembersPortalField[], component: string, componentInstance: string): UpdateComponentFieldSuccess {
    return {
        type: MP_UPDATE_COMPONENT_FIELD_SUCCESS,
        payload: {
            componentFields,
            component,
            componentInstance
        }
    };
}

export function updateFieldComponentRequestFailure(error: string): UpdateComponentFieldFailure {
    return {
        type: MP_UPDATE_COMPONENT_FIELD_FAILURE,
        payload: {
            error
        }
    };
}

export function getFormatFieldsRequest(): GetFormatFieldsRequest {
    return {
        type: MP_GET_FORMAT_FIELDS_REQUEST
    };
}

export function getFormatFieldsSuccess(formatFields: FormatFields[]): GetFormatFieldsSuccess {
    return {
        type: MP_GET_FORMAT_FIELDS_SUCCESS,
        payload: {
            formatFields: formatFields
        }
    };
}


export function getFormatFieldsFailure(error: any): GetFormatFieldsFailure {
    return {
        type: MP_GET_FORMAT_FIELDS_FAILURE,
        payload: {
            error
        }
    };
}

export function applyFormatsWorkMaintenance(): ApplyFormatsWorkMaintenance {
    return {
        type: MP_APPLY_FORMATS_WORK_MAINTENANCE
    }
}
export function expandAllResults(): ExpandAllResults {
    return {
        type: MP_EXPAND_ALL_RESULTS
    }
}

export function enableCustomField(index: number): EnableCustomField {
    return {
        type: MP_ENABLE_CUSTOM_FIELD,
        payload: {
            index
        }
    }
}

export function getUsersRequest(): GetUsersRequest {
    return {
        type: MP_GET_USERS_REQUEST
    };
}

export function getUsersSuccess(users: string[]): GetUsersSuccess {
    return {
        type: MP_GET_USERS_SUCCESS,
        payload: {
            users
        }
    };
}

export function getUsersFailure(error: string): GetUsersFailure {
    return {
        type: MP_GET_USERS_FAILURE,
        payload: { error }
    };
}


export function getUserPreferenceRequest(): GetUserPreferenceRequest {
    return {
        type: MP_GET_USER_PREFERENCES_REQUEST
    }
}
export function getUserPreferenceFailure(): GetUserPreferenceFailure {
    return {
        type: MP_GET_USER_PREFERENCES_FAILURE
    }
}

export function getUserPreferenceSuccess(resultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[]): GetUserPreferenceSuccess {
    return {
        type: MP_GET_USER_PREFERENCES_SUCCESS,
        payload: {
            resultsPerPage: resultsPerPage,
            activeAccordions: activeAccordions
        }
    }

}

export function updateWorkContributorIPRequest(): UpdateWorkContributorIPRequest {
    return {
        type: MP_UPDATE_WORK_CONTRIBUTOR_IP_REQUEST,
    }
}

export function updateWorkContributorIPSuccess(workContributorId: number, ip: IP, agreementChain: IAgreementLink[]): UpdateWorkContributorIPSuccess {
    return {
        type: MP_UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS,
        payload: {
            workContributorId,
            ip,
            agreementChain
        }
    }
}

export function updateWorkContributorIPFailure(): UpdateWorkContributorIPFailure {
    return {
        type: MP_UPDATE_WORK_CONTRIBUTOR_IP_FAILURE,
    }
}

export function getWorkContributorDefaultLegalEntityValueRequest(): GetWorkContributorDefaultLegalEntityValueRequest {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_REQUEST
    }
}

export function getWorkContributorDefaultLegalEntityValueSuccess(defaultLegalEntityValue: string): GetWorkContributorDefaultLegalEntityValueSuccess {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS,
        payload: {
            defaultLegalEntityValue
        }
    }
}

export function getWorkContributorDefaultLegalEntityValueFailure(error: any): GetWorkContributorDefaultLegalEntityValueFailure {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}

export function getShareSetsShownInPortalRequest(): GetShareSetsShownInPortalRequest {
    return {
        type: GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_REQUEST
    }
}

export function getShareSetsShownInPortalSuccess(shareSetsShownInPortal: IPortalShareSetConfiguration[]): GetShareSetsShownInPortalSuccess {
    return {
        type: GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_SUCCESS,
        payload: {
            shareSetsShownInPortal
        }
    }
}

export function getShareSetsShownInPortalFailure(error: any): GetShareSetsShownInPortalFailure {
    return {
        type: GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}

export function getPortalWorkStatusConfigurationRequest(): GetPortalWorkStatusConfigurationRequest {
    return {
        type: GET_PORTAL_WORK_STATUS_CONFIGURATION_REQUEST
    };
}

export function getPortalWorkStatusConfigurationSuccess(portalWorkStatusConfiguration: IPortalWorkStatusConfiguration): GetPortalWorkStatusConfigurationSuccess {
    return {
        type: GET_PORTAL_WORK_STATUS_CONFIGURATION_SUCCESS,
        payload: {
            portalWorkStatusConfiguration
        }
    };
}

export function getPortalWorkStatusConfigurationFailure(error: any): GetPortalWorkStatusConfigurationFailure {
    return {
        type: GET_PORTAL_WORK_STATUS_CONFIGURATION_FAILURE,
        payload: {
            error
        }
    };
}

export function getDefaultSetTypeGroupRequest(): GetDefaultSetTypeGroupRequest {
    return {
        type: GET_DEFAULT_SET_TYPE_GROUP_CONFIG_REQUEST
    }
}

export function getDefaultSetTypeGroupSuccess(defaultSetTypeGroup: string): GetDefaultSetTypeGroupSuccess {
    return {
        type: GET_DEFAULT_SET_TYPE_GROUP_CONFIG_SUCCESS,
        payload: {
            defaultSetTypeGroup
        }
    }
}

export function getDefaultSetTypeGroupFailure(error: any): GetDefaultSetTypeGroupFailure {
    return {
        type: GET_DEFAULT_SET_TYPE_GROUP_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}

export function updateUserPreference(activeAccordions: IActiveAccordion[], resultsPerPage: IResultsPerPage[]): UpdateUserPreference {
    return {
        type: MP_UPDATE_USER_PREFERENCE,
        payload: {
            activeAccordions,
            resultsPerPage
        }
    }

}

export function updatePagination(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string): UpdatePagination {
    return {
        type: MP_UPDATE_PAGINATION,
        payload: {
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            repertoireSection
        }
    }
}

export function sortSearchResults(name: string, results: any): SortSearchResults {
    return {
        type: MP_SORT_SEARCH_RESULTS,
        payload: {
            name,
            results
        }
    }
}

export function resetPagination(repertoireSection: string): ResetPagination {
    return {
        type: MP_RESET_PAGINATION,
        payload: {
            repertoireSection
        }
    };
}

export function setWarningMessage(displayWarning: boolean): SetWarningMessage {
    return {
        type: MP_SET_WARNING_MESSAGE,
        payload: {
            displayWarning
        }
    }
}


export function getMembersPortalComponentDataRequest(): MembersPortalComponentDataRequest {
    return {
        type: MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_REQUEST
    };
}

export function getMembersPortalComponentDataSuccess(
    componentData: IMembersPortalComponentData
): MembersPortalComponentDataSuccess {
    return {
        type: MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_SUCCESS,
        payload: {
            componentData
        }
    };
}

export function getMembersPortalComponentDataFailure(
    error: string
): MembersPortalComponentDataFailure {
    return {
        type: MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_FAILURE,
        payload: { error }
    };
}

export function searchContributorsRequest(): SearchContributorRequest {
    return {
        type: MP_SEARCH_CONTRIBUTORS_REQUEST
    };
}

export function searchContributorsSuccess(
    result: IContributorSearchResult[]
): SearchContributorsSuccess {
    return {
        type: MP_SEARCH_CONTRIBUTORS_SUCCESS,
        payload: {
            contributorsResult: result
        }
    };
}

export function searchContributorsFailure(
    error: string
): SearchContributorsFailure {
    return {
        type: MP_SEARCH_CONTRIBUTORS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchArtistsRequest(): SearchArtistsRequest {
    return {
        type: MP_SEARCH_ARTISTS_REQUEST
    };
}

export function searchArtistsSuccess(result: IArtist[]): SearchArtistsSuccess {
    return {
        type: MP_SEARCH_ARTISTS_SUCCESS,
        payload: {
            artistsResult: result
        }
    };
}

export function searchArtistsFailure(error: string): SearchArtistsFailure {
    return {
        type: MP_SEARCH_ARTISTS_FAILURE,
        payload: {
            error
        }
    };
}

export function addArtistToWork(artist: IArtist, id: number): AddArtistToWork {
    return {
        type: MP_ADD_ARTIST_TO_WORK,
        payload: {
            artist,
            id
        }
    }
}

export function addRepertoireAttachmentRequest(): AddRepertoireAttachmentRequest {
    return {
        type: MP_ADD_REPERTOIRE_ATTACHMENT_REQUEST
    };
}

export function addRepertoireAttachmentSuccess(attachment: IAttachedFile, tabId?: string): AddRepertoireAttachmentSuccess {
    return {
        type: MP_ADD_REPERTOIRE_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment,
            tabId
        }
    };
}

export function addRepertoireAttachmentFailure(error: any): AddRepertoireAttachmentFailure {
    return {
        type: MP_ADD_REPERTOIRE_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}
export function removeWorkAttachmentRequest(): RemoveWorkAttachmentRequest {
    return {
        type: MP_REMOVE_WORK_ATTACHMENT_REQUEST
    };
}

export function removeWorkAttachmentSuccess(attachment: IAttachedFile, tabId?: string): RemoveWorkAttachmentSuccess {
    return {
        type: MP_REMOVE_WORK_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment,
            tabId
        }
    };
}

export function removeWorkAttachmentFailure(error: any): RemoveWorkAttachmentFailure {
    return {
        type: MP_REMOVE_WORK_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function removeAgreementAttachmentRequest(): RemoveAgreementAttachmentRequest {
    return {
        type: MP_REMOVE_AGREEMENT_ATTACHMENT_REQUEST
    };
}

export function removeAgreementAttachmentSuccess(attachment: IAttachedFile, tabId?: string): RemoveAgreementAttachmentSuccess {
    return {
        type: MP_REMOVE_AGREEMENT_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment,
            tabId
        }
    };
}

export function removeAgreementAttachmentFailure(error: any): RemoveAgreementAttachmentFailure {
    return {
        type: MP_REMOVE_AGREEMENT_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function setProgressUploadFileRepertoireProccess(message: string, file: IFile, isUploadComplete: boolean, tabId?: string): SetProgressUploadFileRepertoireProccess {
    return {
        type: MP_SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE,
        payload: {
            message: message,
            file: file,
            isUploadComplete: isUploadComplete,
            tabId
        }
    }
}

export function cleanDroppedFilesRepertoireState(tabId?: string): CleanDroppedFilesState {
    return {
        type: MP_CLEAN_DROPPED_FILES_STATE,
        payload: { tabId }
    }
}

export function addDroppedFile(file: IFile, inProgress: boolean, tabId?: string): AddDroppedFile {
    return {
        type: MP_ADD_DROPPED_FILE,
        payload: {
            file: file,
            inProgress: inProgress,
            tabId
        }
    }
}

export function searchRequestAccessIPRequest(): SearchRequestAccessIP {
    return {
        type: MP_SEARCH_REQUEST_ACCESS_IP
    };
}

export function searchRequestAccessIPRequestSuccess(
    result: IContributorSearchResult[]
): SearchRequestAccessIPSuccess {
    return {
        type: MP_SEARCH_REQUEST_ACCESS_IP_SUCCESS,
        payload: {
            contributorsResult: result
        }
    };
}

export function searchRequestAccessIPRequestFailure(
    error: string
): SearchRequestAccessIPFailure {
    return {
        type: MP_SEARCH_REQUEST_ACCESS_IP_FAILURE,
        payload: {
            error
        }
    };
}

export function requestViewAsAccess(): RequestViewAsAccess {
    return {
        type: MP_REQUEST_VIEW_AS_ACCESS
    };
}

export function requestViewAsAccessSuccess(
    successRes: boolean
): RequestViewAsAccessSuccess {
    return {
        type: MP_REQUEST_VIEW_AS_ACCESS_SUCCESS,
        payload: {
            success: successRes
        }
    };
}

export function requestViewAsAccessFailure(
    error: boolean
): RequestViewAsAccessFailure {
    return {
        type: MP_REQUEST_VIEW_AS_ACCESS_FAILURE,
        payload: {
            error
        }
    };
}

export function getViewAsAccessRequests(): GetViewAsAccessRequests {
    return {
        type: MP_GET_VIEW_AS_ACCESS_REQUESTS
    };
}

export function getViewAsAccessRequestsSuccess(
    viewAsAccessRequests: IViewAsAccessRequest[]
): GetViewAsAccessRequestsSuccess {
    return {
        type: MP_GET_VIEW_AS_ACCESS_REQUESTS_SUCCESS,
        payload: {
            viewAsAccessRequests: viewAsAccessRequests
        }
    };
}

export function getViewAsAccessRequestsFailure(
    error: string
): GetViewAsAccessRequestsFailure {
    return {
        type: MP_GET_VIEW_AS_ACCESS_REQUESTS_FAILURE,
        payload: {
            error
        }
    };
}

export function getMyApplications(): GetMyApplications {
    return {
        type: MP_GET_MY_APPLICATIONS
    };
}

export function getMyApplicationsSuccess(
    applications: IApplication[]
): GetMyApplicationsSuccess {
    return {
        type: MP_GET_MY_APPLICATIONS_SUCCESS,
        payload: {
            applications: applications
        }
    };
}

export function getMyApplicationsFailure(
    error: string
): GetMyApplicationsFailure {
    return {
        type: MP_GET_MY_APPLICATIONS_FAILURE,
        payload: {
            error
        }
    };
}

export function getMyCases(): GetMyCases {
    return {
        type: MP_GET_MY_CASES
    };
}

export function getMyCasesSuccess(
    cases: ICase[]
): GetMyCasesSuccess {
    return {
        type: MP_GET_MY_CASES_SUCCESS,
        payload: {
            cases: cases
        }
    };
}

export function getMyCasesFailure(
    error: string
): GetMyCasesFailure {
    return {
        type: MP_GET_MY_CASES_FAILURE,
        payload: {
            error
        }
    };
}

export function getCRMPowerPortalURL(): GetCRMPowerPortalBaseURLRequest {
    return {
        type: MP_GET_CRM_POWER_PORTAL_BASE_URL_REQUEST
    };
}

export function getCRMPowerPortalURLSuccess(
    powerPortalBaseURL: string
): GetCRMPowerPortalBaseURLSuccess {
    return {
        type: MP_GET_CRM_POWER_PORTAL_BASE_URL_SUCCESS,
        payload: {
            crmPowerPortalBaseURL: powerPortalBaseURL
        }
    };
}

export function getCRMPowerPortalURLFailure(
    error: string
): GetCRMPowerPortalBaseURLFailure {
    return {
        type: MP_GET_CRM_POWER_PORTAL_BASE_URL_FAILURE,
        payload: {
            error
        }
    };
}

export function saveViewAsAccess(): SaveViewAsAccess {
    return {
        type: MP_SAVE_VIEW_AS_ACCESS
    };
}

export function saveViewAsAccessSuccess(
    viewAsAccessRequests: IViewAsAccessRequest[],
    defaultSuccess: boolean
): SaveViewAsAccessSuccess {
    return {
        type: MP_SAVE_VIEW_AS_ACCESS_SUCCESS,
        payload: {
            viewAsAccessRequests: viewAsAccessRequests,
            viewAsAccessSaveSuccess: defaultSuccess
        }
    };
}

export function saveViewAsAccessFailure(
    error: string
): SaveViewAsAccessFailure {
    return {
        type: MP_SAVE_VIEW_AS_ACCESS_FAILURE,
        payload: {
            error
        }
    };
}

export function resetViewAsSaveStatus(): ResetViewAsSaveStatus {
    return {
        type: MP_RESET_VIEW_AS_SAVE_STATUS
    };
}

export function cancelAccessRequest(): CancelAccessRequest {
    return {
        type: MP_CANCEL_ACCESS_REQUEST
    };
}

export function cancelAccessRequestSuccess(
    cancelAccessRequestSuccess: boolean,
    accountNumber: string
): CancelAccessRequestSuccess {
    return {
        type: MP_CANCEL_ACCESS_REQUEST_SUCCESS,
        payload: {
            cancelAccessRequestSuccess: cancelAccessRequestSuccess,
            accountNumber: accountNumber
        }
    };
}

export function cancelAccessRequestFailure(
    error: string
): CancelAccessRequestFailure {
    return {
        type: MP_CANCEL_ACCESS_REQUEST_FAILURE,
        payload: {
            error
        }
    };
}

export function expandWorkResult(workResult: number): ExpandWorkResult {
    return {
        type: MP_EXPAND_WORK_RESULT,
        payload: {
            workResult
        }
    }
}

export function expandProductResult(productResult: number): ExpandProductResult {
    return {
        type: MP_EXPAND_PRODUCT_RESULT,
        payload: {
            productResult
        }
    }
}

export function expandMemberStatementResult(statementResult: number): ExpandMemberStatementResult {
    return {
        type: MP_EXPAND_STATEMENT_RESULT,
        payload: {
            statementResult
        }
    }
}

export function registerStepsSetCurrent(current: number): ReisterStepsSetCurrent {
    return {
        type: MP_REGISTER_STEPS_SET_CURRENT,
        payload: {
            current: current,
        }
    }
};


export function searchMemberStatementsRequest(): SearchMemberStatementsRequest {
    return {
        type: MP_SEARCH_STATEMENTS_REQUEST
    };
}

export function searchMemberStatementsSuccess(statementsResult: IMemberStatementSearchResult[]): SearchMemberStatementsSuccess {
    return {
        type: MP_SEARCH_STATEMENTS_SUCCESS,
        payload: {
            statementsResult
        }
    }
}

export function searchMemberStatementsFailure(error: string): SearchMemberStatementsFailure {
    return {
        type: MP_SEARCH_STATEMENTS_FAILURE,
        payload: {
            error
        }
    };
}

export function claimUnpaidUsageRequest(): ClaimUnpaidUsageRequest {
    return {
        type: MP_CLAIM_UNPAID_USAGE_REQUEST,
    };
}

export function claimUnpaidUsageFailure(): ClaimUnpaidUsageFailure {
    return {
        type: MP_CLAIM_UNPAID_USAGE_FAILURE,
    };
}

export function claimUnpaidUsageSuccess(): ClaimUnpaidUsageSuccess {
    return {
        type: MP_CLAIM_UNPAID_USAGE_SUCCESS,
    };
}

export function searchUnpaidClaimsRequest(): SearchUnpaidClaimsRequest {
    return {
        type: MP_SEARCH_UNPAID_CLAIMS_REQUEST,
    };
}

export function searchClaimsHistoryRequest(): SearchClaimsHistoryRequest {
    return {
        type: MP_SEARCH_CLAIMS_HISTORY_REQUEST,
    };
}

export function searchUnpaidClaimsSuccess(unpaidClaimsResult: IUnpaidClaimsSearchResult[]): SearchUnpaidClaimsSuccess {
    return {
        type: MP_SEARCH_UNPAID_CLAIMS_SUCCESS,
        payload: {
            unpaidClaimsResult
        }
    }
}

export function searchClaimsHistorySuccess(claimsHistoryResult: IClaimsHistorySearchResult[]): SearchClaimsHistorySuccess {
    return {
        type: MP_SEARCH_CLAIMS_HISTORY_SUCCESS,
        payload: {
            claimsHistoryResult
        }
    }
}

export function searchUnpaidClaimsFailure(error: string): SearchUnpaidClaimsFailure {
    return {
        type: MP_SEARCH_UNPAID_CLAIMS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchClaimsHistoryFailure(error: string): SearchClaimsHistoryFailure {
    return {
        type: MP_SEARCH_CLAIMS_HISTORY_FAILURE,
        payload: {
            error
        }
    };
}

export function getMemberStatementDetailsRequest(): GetMemberStatementDetailsRequest {
    return {
        type: MP_GET_STATEMENT_DETAILS_REQUEST
    };
}

export function getMemberStatementDetailsSuccess(statementsResult: IMemberStatementSearchResult): GetMemberStatementDetailsSuccess {
    return {
        type: MP_GET_STATEMENT_DETAILS_SUCCESS,
        payload: {
            statementsResult
        }
    }
}

export function getMemberStatementDetailsFailure(error: string): GetMemberStatementDetailsFailure {
    return {
        type: MP_GET_STATEMENT_DETAILS_FAILURE,
        payload: {
            error
        }
    };
}

export function getMemberStatementPowerBiEmbedRequest(): GetMemberStatementPowerBiEmbedRequest {
    return {
        type: MP_GET_STATEMENT_POWERBI_EMBED_REQUEST
    };
}

export function getMemberStatementPowerBiEmbedSuccess(powerBIEmbedParams: IPowerBIEmbedParams): GetMemberStatementPowerBiEmbedSuccess {
    return {
        type: MP_GET_STATEMENT_POWERBI_EMBED_SUCCESS,
        payload: {
            powerBIEmbedParams
        }
    }
}

export function getMemberStatementPowerBiEmbedFailure(error: string): GetMemberStatementPowerBiEmbedFailure {
    return {
        type: MP_GET_STATEMENT_POWERBI_EMBED_FAILURE,
        payload: {
            error
        }
    };
}

export function addWorkToSetList(work: IDraftWorkSearchResult): AddWorkToSetList {
    return {
        type: MP_ADD_WORK_TO_SET_LIST,
        payload: {
            work
        }
    }
}

export function searchLivePerformancesRequest(): SearchLivePerformancesRequest {
    return {
        type: MP_SEARCH_LIVE_PERFORMANCES_REQUEST
    }
}


export function searchLivePerformancesFailure(error: string): SearchLivePerformancesFailure {
    return {
        type: MP_SEARCH_LIVE_PERFORMANCES_FAILURE,
        payload: {
            error
        }
    }
}
export function searchLivePerformancesSuccess(livePerformancesResult: ILivePerformancesSearchResult): SearchLivePerformancesSuccess {
    return {
        type: MP_SEARCH_LIVE_PERFORMANCES_SUCCESSS,
        payload: {
            livePerformancesResult
        }
    }
}
export function addSetListToLivePerformance(setList: IDraftSetListSearchResult): AddSetListToLivePerformance {
    return {
        type: MP_ADD_SET_LIST_TO_LIVE_PERFORMANCE,
        payload: {
            setList
        }
    }
}

export function getLivePerformanceDetailsRequest(): GetLivePerformanceDetailsRequest {
    return {
        type: MP_GET_LIVE_PERFORMANCE_DETAILS_REQUEST
    }
}
export function getLivePerformanceDetailsSuccess(livePerformanceDetails: IUsageGroup): GetLivePerformanceDetailsSuccess {
    return {
        type: MP_GET_LIVE_PERFORMANCE_DETAILS_SUCCESS,
        payload: {
            livePerformanceDetails
        }
    }
}
export function getLivePerformanceDetailsFailure(error: any, usageId: string): GetLivePerformanceDetailsFailure {
    return {
        type: MP_GET_LIVE_PERFORMANCE_DETAILS_FAILURE,
        payload: {
            error,
            usageId
        }
    }
}

export function getShareDecimalsToDisplayRequest(): GetShareDecimalsToDisplayRequest {
    return {
        type: MP_GET_SHARE_DECIMALS_TO_DISPLAY_REQUEST
    }
}

export function getShareDecimalsToDisplaySuccess(decimalsToDisplay: number): GetShareDecimalsToDisplaySuccess {
    return {
        type: MP_GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS,
        payload: {
            decimalsToDisplay
        }
    }
}

export function getShareDecimalsToDisplayFailure(error: any): GetShareDecimalsToDisplayFailure {
    return {
        type: MP_GET_SHARE_DECIMALS_TO_DISPLAY_FAILURE,
        payload: {
            error
        }
    }
}

export function refreshWorkDetailsRequest(): RefreshWorkDetailsRequest {
    return {
        type: MP_REFRESH_WORK_DETAILS_REQUEST
    };
}

export function refreshWorkDetailsSuccess(result: IWork): RefreshWorkDetailsSuccess {
    return {
        type: MP_REFRESH_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails: result
        }
    };
}

export function refreshWorkDetailsFailure(error: string, workId: number): RefreshWorkDetailsFailure {
    return {
        type: MP_REFRESH_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    };
}

export function refreshAgreementDetailsRequest(): RefreshAgreementDetailsRequest {
    return {
        type: MP_REFRESH_AGREEMENT_DETAILS_REQUEST
    };
}

export function refreshAgreementDetailsSuccess(result: IAgreement): RefreshAgreementDetailsSuccess {
    return {
        type: MP_REFRESH_AGREEMENT_DETAILS_SUCCESS,
        payload: {
            agreementDetails: result
        }
    };
}

export function refreshAgreementDetailsFailure(error: string, agreementId: number): RefreshAgreementDetailsFailure {
    return {
        type: MP_REFRESH_AGREEMENT_DETAILS_FAILURE,
        payload: {
            error,
            agreementId
        }
    };
}

export function addToPackageSuccessMP(results: IAddtoPackageResult): AddToPackageSuccessMP {
    return {
        type: ADD_TO_PACKAGE_SUCCESS_MP,
        payload: {
            results
        }
    };
}


export function replaceTab(tab: ITabReduxItem, targetTabTitle: string): ReplaceTabAction {
    return {
        type: MP_REPLACE_TAB,
        payload: {
            tab,
            targetTabTitle
        }
    }
}

export function getCRMIntegratedEnabledRequest(): GetCRMIntegratedRequest {
    return {
        type: MP_GET_CRM_INTEGRATION_ENABLED_REQUEST
    };
}

export function getCRMIntegratedEnabledSuccess(
    crmIntegrationEnabled: boolean
): GetCRMIntegratedSuccess {
    return {
        type: MP_GET_CRM_INTEGRATION_ENABLED_SUCCESS,
        payload: {
            crmIntegrationEnabled: crmIntegrationEnabled
        }
    };
}

export function getCRMIntegratedEnabledFailure(error: string): GetCRMIntegratedFailure {
    return {
        type: MP_GET_CRM_INTEGRATION_ENABLED_FAILURE,
        payload: {
            error
        }
    };
}


export function getEnabledSetTypeBundleRequest(): GetEnabledSetTypeBundleRequest {
    return {
        type: GET_ENABLED_SET_TYPE_BUNDLE_REQUEST
    }
}

export function getEnabledSetTypeBundleSuccess(enableSetTypeBundle: boolean): GetEnabledSetTypeBundleSuccess {
    return {
        type: GET_ENABLED_SET_TYPE_BUNDLE_SUCCESS,
        payload: { enableSetTypeBundle }
    }
}

export function getEnabledSetTypeBundleFailure(error: string): GetEnabledSetTypeBundleFailure {
    return {
        type: GET_ENABLED_SET_TYPE_BUNDLE_FAILURE,
        payload: { error }
    };
}

export function resetPowerBiEmbedToken(
): ResetPowerBiEmbedToken {
    return {
        type: MP_RESET_POWER_BI_EMBED_TOKEN,
        payload: {
        }
    };
}


export function getPowerBIConfigurationSuccess(
    powerBIAnalyticsConfig: IPowerBIAnalyticsConfig[]
): GetPowerBIAnalyticsConfigurationSuccess {
    return {
        type: MP_GET_POWER_BI_ANALYTICS_CONFIGURATION_SUCCESS,
        payload: {
            powerBIAnalyticsConfig: powerBIAnalyticsConfig
        }
    };
}

export function getPowerBIConfigurationFailure(
    error: string
): GetCRMPowerPortalBaseURLFailure {
    return {
        type: MP_GET_CRM_POWER_PORTAL_BASE_URL_FAILURE,
        payload: {
            error
        }
    };
}


function updateInheritedContributors(work: IWorkState, parentSetType: string): void {
    work.workContributorSetTypes.filter(s => s.inheritFromSetType === parentSetType).map((setType, i) => {
        const contributors: IContributorItem[] = JSON.parse(JSON.stringify(work.contributors[parentSetType]));
        const distributionContributors: IContributorItem[] = work.contributors["distribution"] ? work.contributors["distribution"] : [];
        contributors.forEach((c: IContributorItem, index: number) => {
            if (c.workContributorID && c.workContributorID > 0 && distributionContributors && distributionContributors[index]) {
                c.mechSocietyAffiliation = distributionContributors[index].mechSocietyAffiliation;
                c.perfSocietyAffiliation = distributionContributors[index].perfSocietyAffiliation;
            }
            c.setType = setType.setType;
            c.workContributorID = -Math.abs(c.workContributorID);
            c.agreementChain = []
        });
        work.contributors[setType.setType] = contributors;
    });
}

function clearContributorFields(contributor: IContributorItem): void {
    for (var k in contributor) {
        if (contributor[k] && contributor[k].value && k !== 'role') {
            contributor[k].value = '';
        }
    }
};




const membersPortalReducer = (
    state = initialState,
    action?: ActionTypes
): IMembersPortalState => {

    switch (action.type) {

        case MP_DELETE_DRAFT_WORK_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { workId } = action.payload;
            // TODO John - Review the type here and update to IDraftWorkSearchResult if needed
            let workSearchResult: IDraftWorkSearchResult[] = null;
            if (state.workSearchResult) {
                workSearchResult = [...state.workSearchResult];
                const index = workSearchResult.findIndex(a => a.workID === workId);
                workSearchResult.splice(index, 1);
            }
            return {
                ...state,
                workSearchResult: workSearchResult
            }
        }
        case MP_DELETE_DRAFT_WORK_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                const x: IValidationMessage[] = [];
                if (error) {
                    x.push(error);
                }
                tab.validationMessages = x;
            }
            return {
                ...state,
                tabs: currentTabs
            }
        }

        case GET_USAGEDISTR_SUCCESS: {
            const { distributions } = action.payload;

            let distributionsList: { id: number, code: string; description: string; }[] = [];

            if (distributions && distributions.length > 0) {
                distributions.map(x => {
                    distributionsList.push({ id: x.distributionID, code: x.distributionCode, description: x.distributionCode })
                });
            }
            return {
                ...state,
                distributions: distributionsList
            }
        }

        case MP_CREATE_NEW_DRAFT_WORK: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, formats, currentUserNameNumber, tabId } = action.payload;
            let userNameNumber: number;

            if (currentUserNameNumber)
                userNameNumber = parseInt(currentUserNameNumber);

            const draftWorkDetailsTab: ITabReduxItem = {
                tabId,
                title: "New Draft Work",
                name: "registerNewWork",
                changesMade: true,
                component: DRAFT_WORKS_MAINTENANCE_PAGE.component,
                draftWorkMaintenanceState: {
                    loaded: false,
                    work: WorkDetailsMapper.createNewWorkState(lookups, undefined, undefined, { ipiNameNumber: userNameNumber, workSourceIPID: 0 }),
                    isNew,
                },
                formatFields: formats,
                nextTempID: 0
            };
            const tabs = state.tabs.concat(draftWorkDetailsTab);
            return {
                ...state,
                tabs,
                activeTab: tabs.length - 1
            }
        }

        case MP_CREATE_NEW_DRAFT_AGREEMENT: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, formats, currentUserNameNumber, draftAgreementMaintenanceGeneralDataViewData, tabId } = action.payload;
            let userNameNumber: number;

            if (currentUserNameNumber)
                userNameNumber = parseInt(currentUserNameNumber);
            else {
                return state;
            }

            const draftAgreementDetailsTab: ITabReduxItem = {
                tabId,
                title: "New Draft Agreement",
                name: "registerNewAgreement",
                changesMade: true,
                component: DRAFT_AGREEMENTS_MAINTENANCE_PAGE.component,
                agreementMaintenanceState: {
                    loaded: false,
                    agreement: AgreementDetailsMapper.createNewAgreementState(lookups, draftAgreementMaintenanceGeneralDataViewData, { ipiNameNumber: userNameNumber, agreementSourceIPID: 0, fullName: sessionStorage.getItem('currentViewAsUserName') }),
                    isNew,
                    agreementBatchOperationInProgress: false
                },
                formatFields: formats,
                nextTempID: 0
            };
            const tabs = state.tabs.concat(draftAgreementDetailsTab);
            return {
                ...state,
                tabs,
                activeTab: tabs.length - 1
            }
        }

        case MP_CREATE_NEW_DRAFT_SET_LISTS: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, draftSetListsMaintenanceGeneralDataViewData, formats, currentUserNameNumber, tabId } = action.payload;
            let userNameNumber: number;
            let userName: string;

            if (currentUserNameNumber) {
                userNameNumber = parseInt(currentUserNameNumber);
                userName = sessionStorage.getItem(CURRENT_USER_NAME_KEY);
            }
            const setLists = ProductDetailsMapper.createNewProductState(lookups, formats, { ipiNameNumber: userNameNumber, productSourceIPID: 0, fullName: userName });
            const draftSetListsDetailsTab: ITabReduxItem = {
                tabId,
                title: "New Draft Set Lists",
                name: "registerNewSetLists",
                changesMade: true,
                component: DRAFT_SET_LISTS_MAINTENANCE_PAGE.component,
                draftSetListsMaintenanceState: {
                    loaded: false,
                    setLists: setLists,
                    isNew,
                    dataSource: DataSource.Intray
                },
                formatFields: formats,
                nextTempID: 0,
                isReadonly: false
            };
            const tabs = (state.tabs.findIndex(t => t.title === 'New Draft Set Lists')) < 0 ? state.tabs.concat(draftSetListsDetailsTab) : state.tabs;
            return {
                ...state,
                tabs,
                activeTab: tabs.length - 1,
                dataSource: DataSource.Repertoire
            }
        }

        case GET_UPLOAD_CUE_SHEETS_REQUEST: {
            return {
                ...state,
                isSearching: true
            };
        }

        case GET_UPLOAD_CUE_SHEETS_FAILURE: {
            return updateTabField(state, 'uploadCueSheetsMaintenanceState', [], false);
        }

        case MP_UPLOAD_CUE_FILES_SHEETS: {
            const { formats, currentUserNameNumber, inputFiles, errorsFiles, archiveFiles, tabId } = action.payload;
            const userNameNumber: number = parseInt(currentUserNameNumber ?? null);

            const existingTabIndex = state.tabs.findIndex(t => t.title === 'Upload Cue Sheets');
            let updatedTabs: ITabReduxItem[];
            let newActiveTab: number;
            const selectedFileSystemInput: IFileSystem = {
                name: "input",
                jobTypes: [],
                fullName: "repertoire/portalcues/input",
                parent: null,
                hasMetadata: true,
                canEditMetadata: false,
                fileSystems: [],
                path: "/repertoire/portalcues/input"
            };

            if (existingTabIndex < 0) {
                // Create new tab
                const newTab: ITabReduxItem = {
                    tabId,
                    title: "Upload Cue Sheets",
                    name: "membersPortalUploadCueSheets",
                    changesMade: true,
                    component: UPLOAD_CUE_SHEET_PAGE.component,
                    uploadCueSheetsMaintenanceState: {
                        uploadedCueSheetsInputFiles: inputFiles,
                        uploadedCueSheetsErrorsFiles: errorsFiles,
                        uploadedCueSheetsArchiveFiles: archiveFiles,
                        selectedFileSystem: selectedFileSystemInput
                    },
                    formatFields: formats,
                    nextTempID: 0,
                    isReadonly: false,
                };
                updatedTabs = [...state.tabs, newTab];
                newActiveTab = updatedTabs.length - 1;
            } else {
                // Update existing tab
                updatedTabs = state.tabs.map((tab, index) => {
                    if (index === existingTabIndex) {
                        return {
                            ...tab,
                            uploadCueSheetsMaintenanceState: {
                                ...tab.uploadCueSheetsMaintenanceState,
                                uploadedCueSheetsInputFiles: inputFiles,
                                uploadedCueSheetsErrorsFiles: errorsFiles,
                                uploadedCueSheetsArchiveFiles: archiveFiles,
                                selectedFileSystem: selectedFileSystemInput
                            }
                        };
                    }
                    return tab;
                });
                newActiveTab = existingTabIndex;
            }

            return {
                ...state,
                tabs: updatedTabs,
                activeTab: newActiveTab,
                dataSource: DataSource.Repertoire,
                isSearching: false
            };
        }

        case MP_CREATE_NEW_LIVE_PERFORMANCE: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, formats, distributionCode, currentUserNameNumber, tabId } = action.payload;
            const existingTabIndex = state.tabs.findIndex(t => t.title === "Submit New Live Performance");

            if (existingTabIndex >= 0) {
                return {
                    ...state,
                    activeTab: existingTabIndex
                };
            }

            let userNameNumber: number;
            if (currentUserNameNumber)
                userNameNumber = parseInt(currentUserNameNumber);
            const livePerformance = UsageDetailsMapper.createNewUsageState(lookups, distributionCode, userNameNumber, MEMBERS_PORTAL);
            const livePerformanceDetailsTab: ITabReduxItem = {
                tabId,
                title: "Submit New Live Performance",
                name: "submitNewLivePerformance",
                changesMade: true,
                component: LIVE_PERFORMANCE_MAINTENANCE_PAGE.component,
                livePerformanceMaintenanceState: {
                    loaded: false,
                    usageGroup: livePerformance,
                    isNew,
                    dataSource: DataSource.Intray
                },
                formatFields: formats,
                nextTempID: 0,
                isReadonly: false
            };
            const tabs = state.tabs.concat(livePerformanceDetailsTab);
            return {
                ...state,
                tabs,
                activeTab: tabs.length - 1,
                dataSource: DataSource.Repertoire
            }
        }
        case MP_COPY_DRAFT_WORK: {
            const { userName, lookups } = action.payload;
            if (state.saveInProgress)
                return state;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            let json_work;
            if (tab.registeredWorkMaintenanceState !== undefined) {
                json_work = JSON.stringify(tab.registeredWorkMaintenanceState.work);
            } else {
                json_work = JSON.stringify(tab.draftWorkMaintenanceState.work);
            }
            const workToCopy = JSON.parse(json_work) as IWorkState;
            resetDraftWorkIds(workToCopy, lookups, userName);
            workToCopy.workID = 0;
            workToCopy.dataSource = DataSource.Intray;
            workToCopy.numbers = [];
            workToCopy.contributors = filterValidContributors(workToCopy, lookups);
            const newTab: ITabReduxItem = {
                name: DRAFT_WORKS_STATE_KEY,
                title: undefined,
                component: DRAFT_WORKS_MAINTENANCE_PAGE.component,
                changesMade: true,
                isReadonly: false,
                draftWorkMaintenanceState: {
                    loaded: false,
                    work: workToCopy,
                    isNew: true,
                    isCopy: true
                },
                formatFields: tab.formatFields,
            };
            const tabs = state.tabs.concat(newTab);
            return {
                ...state,
                tabs: tabs,
                activeTab: tabs.length - 1
            }
        }
        case MP_COPY_DRAFT_SET_LIST: {
            const { userName, lookups } = action.payload;
            if (state.saveInProgress)
                return state;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            const setListToCopy = JSON.parse(JSON.stringify(tab.draftSetListsMaintenanceState.setLists));
            const setListId = setListToCopy.productCoreID;
            resetDraftSetListIds(setListToCopy, lookups, userName);
            setListToCopy.productCoreID = 0;
            setListToCopy.dataSource = DataSource.Intray;
            setListToCopy.status = DRAFT_SET_LISTS_STATUS_DRAFT_TYPE;
            const newTab: ITabReduxItem = {
                title: undefined,
                component: DRAFT_SET_LISTS_MAINTENANCE_PAGE.component,
                changesMade: true,
                draftSetListsMaintenanceState: {
                    loaded: false,
                    isNew: true,
                    isCopy: true,
                    setLists: setListToCopy,
                    dataSource: DataSource.Intray
                },

                formatFields: tab.formatFields,
            };
            newTab.title = setListId > 0 ? "Copy of " + setListId : "Copy of New Draft Work";
            const tabs = state.tabs.concat(newTab);
            return {
                ...state,
                tabs: tabs,
                activeTab: tabs.length - 1
            }
        }

        case MP_SEARCH_DRAFT_WORKS_REQUEST: {
            const { isModalSearch } = action.payload
            return {
                ...state,
                isSearching: true,
                isModalSearch
            };
        }

        case MP_SEARCH_DRAFT_AGREEMENTS_REQUEST:
            return {
                ...state,
                isSearching: true
            };

        case MP_SEARCH_DRAFT_AGREEMENTS_IP_REQUEST: {
            const { isModalSearch } = action.payload;

            return {
                ...state,
                isSearching: true,
                isModalSearch: true
            };
        }

        case MP_SEARCH_DRAFT_SET_LISTS_REQUEST:
            return {
                ...state,
                isModalSearch: true,
                isSearching: true
            };

        case MP_UNDO_DRAFT_WORK_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            return {
                saveInProgress: true,
                tabs: currentTabs,
                ...state
            }
        }
        case MP_UNDO_DRAFT_WORK_CHANGES_SUCCESS: {
            const { work, lookupValues } = action.payload;
            const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookupValues);
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.draftWorkMaintenanceState) {
                tab.draftWorkMaintenanceState.work = workState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case GET_MATCHING_SOURCES_SUCCESS: {
            const { sourceSearchResult } = action.payload
            const flattenSourcesArray = (source: ISourceSearchResult[], hierarchyPath: string = '',): ITreeData[] => {
                var result: ITreeData[] = [];
                source.forEach((s) => {
                    if (s.name !== GLOBAL) {
                        result.push({
                            title: s.name,
                            value: s.sourceID,
                            id: s.sourceID,
                            pId: s.parentID,
                            matchType: s.matchType && s.matchType.name != null ? s.matchType.name : '',
                            hierarchy: hierarchyPath + '/' + s.name
                        });
                    }
                    if (Array.isArray(s.children)) {
                        result = result.concat(flattenSourcesArray(s.children, s.name !== GLOBAL ? hierarchyPath + '/' + s.name : GLOBAL));
                    }
                });
                return result;
            }
            const matchingSourceTreeData = flattenSourcesArray(sourceSearchResult);
            return {
                ...state,
                matchingSourceTreeData
            }
        }
        case MP_UNDO_DRAFT_WORK_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.draftWorkMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getDraftWorkDetailsError = error;

            return newState;
        }
        case MP_SAVE_DRAFT_WORK_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            return {
                ...state,
                tabs: currentTabs
            };
        }
        case MP_SAVE_DRAFT_WORK_SUCCESS: {
            const { workSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const work = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookupValues);
                tab.saveSuccessful = workSaveResult.success;
                tab.exportSuccessful = false;
                tab.draftWorkMaintenanceState.work = work;
                tab.draftWorkMaintenanceState.isNew = false;
                tab.draftWorkMaintenanceState.isCopy = false;
                tab.title = getTabTitle(tab);
            }

            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false
            };
        }
        case MP_SAVE_DRAFT_AGREEMENT_SUCCESS: {
            const { agreementSaveResult, resetChangesMade } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const agreement = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);
                tab.saveSuccessful = agreementSaveResult.success;
                tab.exportSuccessful = false;
                tab.agreementMaintenanceState.agreement = agreement;
                tab.agreementMaintenanceState.isNew = false;
                tab.agreementMaintenanceState.isCopy = false;
                tab.title = `(${agreement.agreementID}) ${agreement.ipNameNumber}`;
                if (!resetChangesMade) {
                    tab.changesMade = false;
                }
            }

            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false
            };
        }
        case MP_SAVE_DRAFT_WORK_FAILURE: {
            const { workSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const work = workSaveResult && workSaveResult.work ? WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookupValues) : tab.draftWorkMaintenanceState.work;
                tab.draftWorkMaintenanceState.work = work;
                tab.changesMade = !(workSaveResult && workSaveResult.saved);
                tab.saveSuccessful = !!(workSaveResult && workSaveResult.saved);
                const x: IValidationMessage[] = [];
                if (workSaveResult && workSaveResult.messages && Array.isArray(workSaveResult.messages) && workSaveResult.messages.length > 0) {
                    workSaveResult.messages.map(m => x.push({ messageKey: (m && m.messageKey) || "saveFailedMessage", additionalInfo: m && m.additionalInfo }));
                } else {
                    x.push({ messageKey: "saveFailedMessage", additionalInfo: undefined });
                }
                tab.validationMessages = x;
            }

            return {
                ...state,
                tabs: currentTabs
            };

        }

        case MP_SAVE_DRAFT_AGREEMENT_FAILURE: {
            const { agreementSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const agreement = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);
                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = !agreementSaveResult.saved;
                tab.saveSuccessful = agreementSaveResult.saved;
                tab.validationMessages = agreementSaveResult.messages || [];
            }

            return {
                ...state,
                tabs: currentTabs
            };

        }


        case MP_SAVE_DRAFT_SET_LISTS_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            return {
                ...state,
                tabs: currentTabs
            };
        }

        case MP_SAVE_DRAFT_SET_LISTS_SUCCESS: {
            const { setListsSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const setList = ProductDetailsMapper.mapProductToState(setListsSaveResult.product);
                tab.saveSuccessful = setListsSaveResult.success;
                tab.exportSuccessful = false;
                tab.draftSetListsMaintenanceState.setLists = setList;
                tab.draftSetListsMaintenanceState.isNew = false;
                tab.draftSetListsMaintenanceState.isCopy = false;
                tab.title = ProductDetailsMapper.getOriginalTitleFromProductNames(setListsSaveResult.product.productNames);
                tab.changesMade = false
            }

            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false
            };
        }
        case MP_SAVE_DRAFT_LIVE_PERFORMANCE_SUCCESS: {
            const { usageSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                let productMatchingRows = [];
                usageSaveResult.usageGroup.matches.map(x => productMatchingRows.push({
                    ...x.productData,
                    matchType: x.matchType
                }));

                const usage = UsageDetailsMapper.mapUsageToState(usageSaveResult.usageGroup, [], productMatchingRows, true);
                usage.livePerformanceSetList = (usageSaveResult.usageGroup.matches && usageSaveResult.usageGroup.matches.length > 0) ?
                    {
                        artist: usageSaveResult.usageGroup.matches[0].productData.artist,
                        contributor: usageSaveResult.usageGroup.matches[0].productData.contributor,
                        dataSource: DataSource.Repertoire,
                        id1: usageSaveResult.usageGroup.matches[0].productData.id1,
                        id2: usageSaveResult.usageGroup.matches[0].productData.id2,
                        number: [usageSaveResult.usageGroup.matches[0].productData.id1],
                        productCoreID: usageSaveResult.usageGroup.matches[0].productData.productCoreID,
                        productStatus: usageSaveResult.usageGroup.matches[0].productData.status,
                        setListID: usageSaveResult.usageGroup.matches[0].productData.id1,
                        source: usageSaveResult.usageGroup.matches[0].productData.source,
                        title: usageSaveResult.usageGroup.matches[0].productData.title,
                        type: usageSaveResult.usageGroup.matches[0].productData.type,
                        dateCreated: undefined
                    } : undefined;
                tab.saveSuccessful = usageSaveResult.success;
                tab.exportSuccessful = false;
                tab.livePerformanceMaintenanceState.usageGroup = usage;
                tab.livePerformanceMaintenanceState.isNew = false;
                tab.title = UsageDetailsMapper.getUsageTitle(usageSaveResult.usageGroup);
                tab.changesMade = false
            }
            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false
            };
        }
        case MP_SAVE_DRAFT_SET_LISTS_FAILURE: {
            const { setListsSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const setList = ProductDetailsMapper.mapProductToState(setListsSaveResult.product, undefined, true);
                tab.draftSetListsMaintenanceState.setLists = setList;
                tab.changesMade = !setListsSaveResult.saved;
                tab.saveSuccessful = setListsSaveResult.saved;
                const x: IValidationMessage[] = [];
                setListsSaveResult.messages.map(m => x.push({ messageKey: m.messageKey }));
                tab.validationMessages = x;
            }

            return {
                ...state,
                tabs: currentTabs
            };

        }

        case GET_SET_LIST_WORK_DEFAULT_DURATION_CONFIG_SUCCESS: {
            const { setListWorksDefaultDuration } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            if (tab?.draftSetListsMaintenanceState?.setLists) {
                tab.draftSetListsMaintenanceState.setLists.defaultWorkDuration = setListWorksDefaultDuration ?? 0;
            }
            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_SAVE_DRAFT_LIVE_PERFORMANCE_FAILURE: {
            const { usageSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = !usageSaveResult.saved;
                tab.saveSuccessful = usageSaveResult.saved;
                const x: IValidationMessage[] = [];
                usageSaveResult.messages.map(m => x.push({ messageKey: m.messageKey }));
                tab.validationMessages = x;
            }

            return {
                ...state,
                tabs: currentTabs
            };

        }
        case MP_UNDO_DRAFT_SET_LIST_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            return {
                saveInProgress: true,
                tabs: currentTabs,
                ...state,
            }
        }
        case MP_UNDO_DRAFT_SET_LIST_CHANGES_SUCCESS: {
            const { product } = action.payload;
            const productState = ProductDetailsMapper.mapProductToState(product);
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.draftSetListsMaintenanceState) {
                tab.draftSetListsMaintenanceState.setLists = productState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case MP_UNDO_DRAFT_SET_LIST_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.draftSetListsMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getDraftSetListDetailsError = error;

            return newState;
        }
        case MP_SEARCH_LICENSE_VENUES_SUCCESS: {
            const { licenseVenuesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.licenseVenuesSearchResults = licenseVenuesResult;
            if (!tab.licenseVenues) {
                tab.licenseVenues = [];
            }
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            tab.changesMade = true;
            return newState;

        }
        case MP_SEARCH_DRAFT_SET_LISTS_SUCCESS: {
            const { setListsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftSetListSearchResult = setListsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.isModalSearch = false;
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_UPDATE_DRAFT_WORK_FIELD: {
            const { value, fieldName, index } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.draftWorkMaintenanceState && tab.draftWorkMaintenanceState.work) {
                const work: any = Object.assign({}, tab.draftWorkMaintenanceState.work);

                if (fieldName === DRAFT_WORKS_TITLES_STATE_KEY) {
                    const originalTitle = work.titles?.find(x => x?.type?.value === "OT");
                    work[fieldName] = originalTitle ? [originalTitle, ...value] : value;
                }
                else {
                    work[fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>;
                }

                tab.draftWorkMaintenanceState.work = work;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }

        case MP_ADD_LICENSE_VENUE_TO_USAGE: {
            const { licenseVenue } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const updatedState: IMembersPortalState = Object.assign({}, state);
            updatedState.tabs = currentTabs;
            let tab = currentTabs[state.activeTab];

            if (tab && tab.livePerformanceMaintenanceState && tab.livePerformanceMaintenanceState.usageGroup) {
                const usageGroup = { ...tab.livePerformanceMaintenanceState.usageGroup };
                usageGroup.venueDetails = {
                    venueCode: licenseVenue.venueCode,
                    venueName: licenseVenue.venueName,
                    venueLookupType: licenseVenue.venueType,
                    firstName: licenseVenue.contactFirstName,
                    lastName: licenseVenue.contactLastName,
                    phoneNumber: licenseVenue.contactPhoneNumber,
                    venueType: licenseVenue.venueType,
                    region: licenseVenue.region,
                    city: licenseVenue.city,
                    country: licenseVenue.country
                };
                usageGroup.location = {
                    addDetailsManually: true,
                    city: usageGroup.venueDetails.city ?? "",
                    country: usageGroup.venueDetails.country ?? "",
                    venue: usageGroup.venueDetails.venueName ?? "",
                    region: usageGroup.venueDetails.region ?? ""
                };
                tab.livePerformanceMaintenanceState.usageGroup = usageGroup;
                tab.changesMade = true;
            }
            return updatedState;
        }

        case MP_UPDATE_DRAFT_AGREEMENT_FIELD: {
            const { value, fieldName, index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);

                switch (fieldName) {
                    case "ipName":
                        agreement.ipBaseNumber = value.ipBaseNumber;
                        agreement.ipName = value.ipName;
                        agreement.ipNameNumber = value.ipNameNumber;
                        agreement.societyAffiliation = value.societyAffiliation;
                        break;

                    case "effectiveFrom":
                        agreement[fieldName] = value ? `${value}T00:00:00` : null;
                        break;

                    case "effectiveTo":
                        agreement[fieldName] = value ? `${value}T23:59:59` : null;
                        break;

                    default:
                        agreement[fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>;
                        break;
                }

                if (fieldName === 'agreementTerritory') {
                    agreement.agreementRegion = [];
                }

                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case MP_UPDATE_DRAFT_AGREEMENT_WORK_FIELD: {
            const { value, fieldName, index } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                agreement[fieldName][index]['agreementWorkID'] = agreement.agreementWorkID ? agreement.agreementWorkID : 0;
                agreement[fieldName][index]['type'] = { value: tab.agreementMaintenanceState.agreement?.applicableWorksType ? tab.agreementMaintenanceState.agreement?.applicableWorksType : 'INC', inputType: 'dropdown' };
                agreement[fieldName][index]['workID'] = value.workID;
                agreement[fieldName][index]['workName'].value = value.title?.length > 0 ? value.title[0] : value.title;
                agreement[fieldName][index]['workNumber'].value = value.number?.length > 0 ? value.number[0] : value.number;
                agreement[fieldName][index]['agreementID'] = agreement.agreementID;
                agreement[fieldName][index]['isChanged'] = true;
                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }


        case MP_UPDATE_LIVE_PERFORMANCE_FIELD: {
            const { value, fieldName, index } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.livePerformanceMaintenanceState && tab.livePerformanceMaintenanceState.usageGroup) {

                if (fieldName === LIVE_PERFORMANCE_OTHER_ARTIST_PERFORM_STATE_KEY || fieldName === LIVE_PERFORMANCE_PROMOTER_STATE_KEY || fieldName === LIVE_PERFORMANCE_STAGE_STATE_KEY || fieldName === LIVE_PERFORMANCE_PERFORMANCE_TYPE_STATE_KEY) {
                    const usage: any = Object.assign({}, tab.livePerformanceMaintenanceState.usageGroup);
                    usage["setListAdditional"][fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                    tab.livePerformanceMaintenanceState.usageGroup = usage;
                    tab.changesMade = true;
                }
                else if (fieldName === LIVE_PERFORMANCE_VENUE_LOOKUP_TYPE_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_CONTACT_FIRST_NAME_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_CONTACT_LAST_NAME_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_CONTACT_PHONE_NUMBER_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_TYPE_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_OTHER_VENUE_TYPE_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_NAME_STATE_KEY || fieldName === LIVE_PERFORMANCE_VENUE_CODE_STATE_KEY) {
                    const usage: any = Object.assign({}, tab.livePerformanceMaintenanceState.usageGroup);
                    usage["venueDetails"][fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                    tab.livePerformanceMaintenanceState.usageGroup = usage;
                    tab.changesMade = true;
                }
                else if (fieldName === LIVE_PERFORMANCE_VENUE_LOOKUP_TYPE_STATE_KEY) {
                    const usage: any = Object.assign({}, tab.livePerformanceMaintenanceState.usageGroup);
                    usage["venueLookupDetails"][fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                    tab.livePerformanceMaintenanceState.usageGroup = usage;
                    tab.changesMade = true;
                }
                else if (fieldName === LIVE_PERFORMANCE_START_TIME_STATE_KEY || fieldName === LIVE_PERFORMANCE_END_TIME_STATE_KEY || fieldName === LIVE_PERFORMANCE_PERFORMANCE_DATE_STATE_KEY) {
                    const usage: any = Object.assign({}, tab.livePerformanceMaintenanceState.usageGroup);
                    usage.usages[0][fieldName] = { value: value, inputType: '' } as unknown as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                    tab.livePerformanceMaintenanceState.usageGroup = usage;
                    tab.changesMade = true;
                }
                else {
                    const livePerformance: any = Object.assign({}, tab.livePerformanceMaintenanceState.usageGroup);
                    livePerformance[fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                    tab.livePerformanceMaintenanceState.usageGroup = livePerformance;
                    tab.changesMade = tab.isReadonly ? tab.changesMade : true;
                }
            }
            return newState;
        }

        case MP_UPDATE_DRAFT_SET_LISTS_FIELD: {
            const { value, fieldName, index } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.draftSetListsMaintenanceState && tab.draftSetListsMaintenanceState.setLists) {
                const setList: any = Object.assign({}, tab.draftSetListsMaintenanceState.setLists);
                setList[fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                tab.draftSetListsMaintenanceState.setLists = setList;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case MP_SEARCH_DRAFT_WORKS_SUCCESS: {
            const { draftWorksResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftWorkSearchResult = draftWorksResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = undefined;
            return newState;
        }
        case MP_SEARCH_DRAFT_WORKS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftWorkSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_DRAFT_AGREEMENTS_SUCCESS: {
            const { draftAgreementsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftAgreementSearchResult = draftAgreementsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = undefined;
            return newState;
        }

        case MP_SEARCH_DRAFT_AGREEMENTS_IP_SUCCESS: {
            const { draftAgreementsIPResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftAgreementIPSearchResult = draftAgreementsIPResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = false;
            return newState;
        }

        case MP_SEARCH_DRAFT_AGREEMENTS_WORKS_SUCCESS: {

            const { draftAgreementsWorksResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftAgreementWorksSearchResult = draftAgreementsWorksResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = undefined;
            return newState;
        }


        case MP_SEARCH_DRAFT_AGREEMENTS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftWorkSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_REGISTERED_AGREEMENTS_REQUEST: {
            return {
                ...state,
                isSearching: true
            };
        }
        case MP_SEARCH_REGISTERED_AGREEMENTS_SUCCESS: {
            const { registeredAgreementsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.registeredAgreementSearchResult = registeredAgreementsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_REGISTERED_AGREEMENTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.registeredAgreementSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_DRAFT_SET_LISTS_SUCCESS: {
            const { setListsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftSetListSearchResult = setListsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_REGISTERED_SET_LISTS_SUCCESS: {
            const { registeredSetListsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.registeredSetListsSearchResult = registeredSetListsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_CUE_SHEETS_REQUEST:
            return {
                ...state,
                isSearching: true
            };
        case MP_SEARCH_CUE_SHEETS_SUCCESS:
            return updateTabField(state, 'cueSheetsSearchResults', action.payload.cueSheetsResult, true);
        case MP_SEARCH_CUE_SHEETS_FAILURE:
            return updateTabField(state, 'cueSheetsSearchResults', [], false);

        case MP_SEARCH_DRAFT_SET_LISTS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.draftSetListSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.isModalSearch = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_GET_DRAFT_WORK_ID_SUCCESS: {
            const { workIDs } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            newState.searchSuccessful = true;
            newState.isSearching = false;
            return newState;
        }
        case MP_INCREMENT_TEMPID: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab.nextTempID === undefined)
                tab.nextTempID = 0
            else
                tab.nextTempID--;

            return newState;
        }

        case MP_SET_WARNING_MESSAGE: {
            const { displayWarning } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            tab.sharesWarning = displayWarning;

            return {
                ...state,
                tabs: currentTabs
            }
        }


        case MP_UPDATE_USER_PREFERENCE: {
            const { activeAccordions, resultsPerPage } = action.payload;

            const defaultActiveAccordionsList: IActiveAccordion[] = [];
            const resultsPerPageList: IResultsPerPage[] = [];

            if (activeAccordions)
                activeAccordions.map(daa => defaultActiveAccordionsList.push(Object.assign({}, daa)));
            if (resultsPerPage)
                resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));

            return {
                ...state,
                defaultActiveAccordions: defaultActiveAccordionsList,
                resultsPerPage: resultsPerPageList
            }
        }

        case MP_GET_USER_PREFERENCES_SUCCESS: {
            const { activeAccordions, resultsPerPage } = action.payload;

            return {
                ...state,
                defaultActiveAccordions: activeAccordions,
                resultsPerPage: resultsPerPage
            };
        }
        case MP_SORT_SEARCH_RESULTS: {
            const { name, results } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];

            if (tab) {
                switch (name) {
                    case SEARCH_VIEW_DRAFT_WORKS: {
                        tab.draftWorkSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_REGISTERED_WORKS: {
                        tab.registeredWorkSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_ALL_REGISTERED_WORKS: {
                        tab.allRegisteredWorkSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_DRAFT_AGREEMENTS: {
                        tab.draftAgreementSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_REGISTERED_AGREEMENTS: {
                        tab.registeredAgreementSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_REGISTERED_CUE_SHEETS: {
                        tab.cueSheetsSearchResults = results;
                        break;
                    }
                    case SEARCH_VIEW_CLAIMS_HISTORY: {
                        if (tab.claimsHistorySearchResults) {
                            tab.claimsHistorySearchResults.priorClaims = results;
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_UPDATE_PAGINATION: {
            const { indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            let resultsPerPageList: IResultsPerPage[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            if (tab) tab.currentPage = currentPage;

            state.resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));
            const rpp = resultsPerPageList.find(r => r.repertoireSection === repertoireSection);

            if (rpp) {
                rpp.resultsPerSection = resultsPerPage;
                rpp.indexOfFirstResult = indexOfFirstResult;
                rpp.indexOfLastResult = indexOfLastResult;
            } else {
                resultsPerPageList.push({
                    repertoireSection,
                    resultsPerSection: resultsPerPage,
                    indexOfFirstResult,
                    indexOfLastResult
                });
            }

            return {
                ...state,
                tabs: currentTabs,
                resultsPerPage: resultsPerPageList
            }
        }
        case MP_RESET_PAGINATION: {
            const { repertoireSection } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const resultsPerPageList: IResultsPerPage[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            if (tab) tab.currentPage = 1;

            state.resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));
            const rpp = resultsPerPageList.find(r => r.repertoireSection === repertoireSection);
            if (rpp) {
                rpp.indexOfFirstResult = 0;
                rpp.indexOfLastResult = rpp.resultsPerSection;
            } else {
                resultsPerPageList.push({
                    repertoireSection,
                    resultsPerSection: 10,
                    indexOfFirstResult: 0,
                    indexOfLastResult: 10
                });
            }

            return {
                ...state,
                tabs: currentTabs,
                resultsPerPage: resultsPerPageList
            }
        }

        case MP_EXPAND_WORK_RESULT: {
            const { workResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                if (tab.expandedWorkResults && tab.expandedWorkResults.includes(workResult)) {
                    tab.expandedWorkResults.splice(tab.expandedWorkResults.indexOf(workResult), 1);
                }
                else {
                    if (tab.expandedWorkResults === undefined) {
                        tab.expandedWorkResults = [];
                    }
                    tab.expandedWorkResults.push(workResult);
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }

        case MP_EXPAND_PRODUCT_RESULT: {
            const { productResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                if (tab.expandedProductResults && tab.expandedProductResults.includes(productResult)) {
                    tab.expandedProductResults.splice(tab.expandedProductResults.indexOf(productResult), 1);
                }
                else {
                    if (tab.expandedProductResults === undefined) {
                        tab.expandedProductResults = [];
                    }
                    tab.expandedProductResults.push(productResult);
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }

        case MP_EXPAND_ALL_RESULTS: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                tab.expandedWorkResults = [];
                tab.expandedProductResults = [];
                if (!tab.expandAll) {
                    tab.expandAll = true;
                    for (let i = 0; i < 100; i++) {
                        tab.expandedProductResults.push(i);
                        tab.expandedWorkResults.push(i);
                    }
                }
                else {
                    tab.expandAll = !tab.expandAll;
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }

        case MP_ENABLE_CUSTOM_FIELD: {
            const { index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                if (tab.customFields && tab.customFields.includes(index)) {
                    tab.customFields.splice(tab.customFields.indexOf(index), 1);
                }
                else {
                    if (tab.customFields === undefined) {
                        tab.customFields = [];
                    }
                    tab.customFields.push(index);
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_GET_FORMAT_FIELDS_SUCCESS: {
            const { formatFields } = action.payload

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                if (formatFields) {
                    tab.formatFields = formatFields;

                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_SET_EDITABLE_FIELDS_TAB: {

            const { componentFieldName, componentInstance } = action.payload;

            const componentData = state.componentData[componentFieldName]
            const fields = componentData.fields.filter(x => x.componentInstance === componentInstance);

            const editableFields = JSON.parse(JSON.stringify(fields));
            const currentTabs: ITabReduxItem[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.editableFields = editableFields
            }
            const newState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.tabs = currentTabs;

            return newState;
        }
        case MP_DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS: {
            const { useRelationshipflag } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);

                if (agreement.agreementID === 0) {
                    agreement.useRelationships = useRelationshipflag
                }
                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case MP_DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS: {
            const { isAppliedAtIPNameNumberLevelflag } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);

                if (agreement.agreementID === 0) {
                    agreement.isAppliedAtIPNameNumberLevel = isAppliedAtIPNameNumberLevelflag
                }
                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case MP_UPDATE_EDITABLE_FIELD: {
            const { value } = action.payload;

            const currentTabs: ITabReduxItem[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.editableFields = value
            }
            const newState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.tabs = currentTabs;

            return newState;

        }
        case MP_UPDATE_COMPONENT_FIELD_REQUEST: {
            return {
                ...state,
                saveInProgress: false
            };
        }
        case MP_UPDATE_COMPONENT_FIELD_FAILURE: {
            return {
                ...state
            }
        }
        case MP_UPDATE_COMPONENT_FIELD_SUCCESS: {
            const { componentFields, component } = action.payload;
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.componentData = Object.assign({}, newState.componentData) as IMembersPortalComponentData;
            newState.componentData[component] = { fields: componentFields };
            newState.saveInProgress = false;

            return newState;
        }

        case MP_OPEN_ACCORDION: {
            const { accordionName, componentName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const tab = currentTabs[state.activeTab];
            if (!tab)
                return state;
            if (!tab.activeAccordions) {
                tab.activeAccordions = [accordionName];
            } else {
                tab.activeAccordions.push(accordionName);
            }

            let defaultActiveAccordions: IActiveAccordion[] = [];
            state.defaultActiveAccordions.map(a => defaultActiveAccordions.push(Object.assign({}, a)));
            let defaultAccordion = defaultActiveAccordions.find((a) => a.fieldName === accordionName);
            if (defaultAccordion) {
                if (!defaultAccordion.componentName)
                    defaultAccordion.componentName = componentName;
                if (defaultAccordion.isExpanded !== true) {
                    defaultAccordion = {
                        componentName: componentName,
                        fieldName: accordionName,
                        isExpanded: true
                    };
                }
            } else {
                const newAccordion = {
                    componentName: componentName,
                    fieldName: accordionName,
                    isExpanded: true
                };
                defaultActiveAccordions.push(newAccordion);
            }
            return {
                ...state,
                defaultActiveAccordions: defaultActiveAccordions,
                tabs: currentTabs,
            };
        }
        case MP_CLOSE_ACCORDION: {
            const { accordionName, componentName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const tab = currentTabs[state.activeTab];
            if (!tab)
                return state;
            let indexToRemove = tab.activeAccordions.findIndex(x => x === accordionName);
            tab.activeAccordions.splice(indexToRemove, 1);

            let defaultActiveAccordions: IActiveAccordion[] = [];
            state.defaultActiveAccordions.map(a => defaultActiveAccordions.push(Object.assign({}, a)));
            let defaultAccordion = defaultActiveAccordions.find((a) => a.fieldName === accordionName && a.componentName === componentName);
            if (defaultAccordion && defaultAccordion.isExpanded === true) {
                defaultAccordion.isExpanded = false;
            } else {
                const newAccordion = {
                    componentName: componentName,
                    fieldName: accordionName,
                    isExpanded: false
                };
                defaultActiveAccordions.push(newAccordion);
            }

            return {
                ...state,
                defaultActiveAccordions: defaultActiveAccordions,
                tabs: currentTabs
            };
        }
        case MP_SET_CHANGES_MADE: {
            const { tabIndex, changesMade } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex !== null ? tabIndex : state.activeTab];
            if (tab)
                tab.changesMade = changesMade;
            return {
                ...state,
                tabs: currentTabs
            };
        }
        case ADD_TO_PACKAGE_REQUEST: {
            return {
                ...state,
                packageOperationInProgress: true,
            };
        }

        case ADD_TO_PACKAGE_FAILURE: {
            return {
                ...state,
                packageOperationInProgress: false,
            };
        }

        case ADD_TO_PACKAGE_SUCCESS: {
            const { results } = action.payload;
            const updatedPackage = results.MyPackages;

            const tabs = state.tabs.map(tab => {
                const existingResult: any = tab.myPackagesResult;

                const existingPackages =
                    Array.isArray(existingResult)
                        ? existingResult
                        : Array.isArray(existingResult?.data)
                            ? existingResult.data
                            : [];

                return {
                    ...tab,
                    myPackagesResult: updatedPackage
                        ? [
                            updatedPackage,
                            ...existingPackages.filter(
                                packageItem =>
                                    String(packageItem.id) !==
                                    String(updatedPackage.id)
                            ),
                        ]
                        : existingResult,
                    saveSuccessful: results.success,
                    changesMade: false,
                    matchingSuccessful: undefined,
                    postSuccessful: undefined,
                    validationMessages: results.messages,
                };
            });

            return {
                ...state,
                tabs,
                packageOperationInProgress: false,
            };
        }
        case GET_ALL_PACKAGES_DETAILS_SUCCESS: {
            const { myPackagesDetails } = action.payload;

            const currentTabs = state.tabs.map(tab => ({
                ...tab,
                myPackagesResult: myPackagesDetails,
                myPackagesGeneratePackageMessage: null,
            }));

            const packages =
                (myPackagesDetails as any)?.data ??
                myPackagesDetails;

            const fullCataloguePackagePending =
                Array.isArray(packages) &&
                packages.some(packageItem =>
                    packageItem?.entityType === "Works" &&
                    packageItem?.status === "Open" &&
                    Boolean(packageItem?.searchCriteriaJson)
                );

            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false,
                fullCataloguePackagePending,
                packageOperationInProgress: false,
            };
        }
        case GENERATE_PACKAGE_REQUEST: {
            return {
                ...state,
                packageOperationInProgress: true,
            };
        }
        case GENERATE_PACKAGE_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);
            if (tab) {
                tab.myPackagesGeneratePackageMessage = "packageGeneratingMessage";
            }
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            newState.fullCataloguePackagePending = false;
            newState.packageOperationInProgress = false;
            return newState;
        }
        case GENERATE_PACKAGE_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.myPackagesGeneratePackageMessage = "packageGenerationFailureMessage";
            }
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            newState.packageOperationInProgress = false;
            return newState;
        }
        case MP_CLEAR_MODAL_SEARCH_RESULTS: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (state.searchSuccessful) {
                tab.contributorsSearchResult = undefined;
                tab.artistsSearchResult = undefined;
            }
            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_ADD_TAB: {
            if (state.saveInProgress)
                return state;
            const { tab, keepTitle } = action.payload;

            if (!keepTitle)
                tab.title = getTabTitle(tab);

            let currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tabToOpenIndex = currentTabs.findIndex(x => x.title === tab.title);
            tab.droppedFiles = {
                inDropZone: false,
                files: []
            }
            tab.nextTempID = 0;

            state.defaultActiveAccordions.forEach((a, i) => {
                if (a.isExpanded)
                    if (!tab.activeAccordions)
                        tab.activeAccordions = [a.fieldName];
                    else
                        tab.activeAccordions.push(a.fieldName);
            });

            if (tabToOpenIndex >= 0) {

                if (tab.component === CUE_SHEETS_MAINTENANCE_PAGE.component) {
                    const targetProductCoreID = tab.cueSheetMaintenanceState?.cueSheets?.productCoreID;

                    const tabToOpenIndexSecondCheck = currentTabs.findIndex(t =>
                        t.component === CUE_SHEETS_MAINTENANCE_PAGE.component &&
                        t.cueSheetMaintenanceState?.cueSheets &&
                        t.cueSheetMaintenanceState.cueSheets.dataSource === tab.cueSheetMaintenanceState?.cueSheets?.dataSource &&
                        Number(t.cueSheetMaintenanceState.cueSheets.productCoreID) === Number(targetProductCoreID)
                    );

                    if (tabToOpenIndexSecondCheck >= 0) {
                        tabToOpenIndex = tabToOpenIndexSecondCheck;

                        return {
                            ...state,
                            tabs: currentTabs,
                            activeTab: tabToOpenIndex
                        }
                    }
                    else {
                        currentTabs = currentTabs.concat(tab);
                        tabToOpenIndex = currentTabs.findIndex(x => x === tab);
                    }

                }
                else {
                    return {
                        ...state,
                        tabs: currentTabs,
                        activeTab: tabToOpenIndex
                    }
                }

            }
            else {
                currentTabs = currentTabs.concat(tab);
                tabToOpenIndex = currentTabs.findIndex(x => x === tab);
            }
            return {
                ...state,
                searchSuccessful: undefined,
                tabs: currentTabs,
                activeTab: tabToOpenIndex
            };
        }
        case MP_REPLACE_TAB: {
            if (state.saveInProgress)
                return state;
            const { tab, targetTabTitle } = action.payload;
            let currentTabs: ITabReduxItem[] = state.tabs.map(t => Object.assign({}, t));
            let tabToReplaceIndex = tab.tabId ? currentTabs.findIndex(x => x.tabId === tab.tabId) : currentTabs.findIndex(x => x.title === targetTabTitle);
            if (tabToReplaceIndex >= 0) {
                currentTabs[tabToReplaceIndex] = tab;
                currentTabs[tabToReplaceIndex].tabTitle = tab.title;
                return {
                    ...state,
                    tabs: currentTabs,
                    activeTab: tabToReplaceIndex
                };
            } else {
                currentTabs = currentTabs.concat(tab);
                tabToReplaceIndex = currentTabs.length - 1;
                return {
                    ...state,
                    searchSuccessful: undefined,
                    tabs: currentTabs,
                    activeTab: tabToReplaceIndex
                };
            }
        }
        case MP_REMOVE_TAB: {
            if (state.saveInProgress)
                return state;
            let newTabs: ITabReduxItem[] = JSON.parse(JSON.stringify(state.tabs));
            if (newTabs[action.payload.index].activeAccordions) {
                newTabs[action.payload.index].activeAccordions = undefined;
            }
            newTabs.splice(action.payload.index, 1);
            return {
                ...state,
                tabs: newTabs,
                activeTab: state.activeTab == 0 ? 0 : state.activeTab < action.payload.index ? state.activeTab : state.activeTab - 1
            };
        }
        case MP_OPEN_TAB: {
            if (state.saveInProgress)
                return state;
            const { index } = action.payload;
            return {
                ...state,
                activeTab: index
            }
        }

        case MP_FETCH_MEMBERS_PORTAL_COMPONENT_DATA_SUCCESS: {
            const { componentData } = action.payload;
            return {
                ...state,
                componentData
            };
        }

        case MP_DELETE_REGISTERED_WORK_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { workId } = action.payload;
            let registeredWorkSearchResult: IRegisteredWork[] = null;
            if (state.registeredWorkSearchResult) {
                registeredWorkSearchResult = [...state.registeredWorkSearchResult];
                const index = registeredWorkSearchResult.findIndex(a => a.workID === workId);
                registeredWorkSearchResult.splice(index, 1);
            }
            return {
                ...state,
                registeredWorkSearchResult: registeredWorkSearchResult
            }
        }
        case MP_DELETE_REGISTERED_WORK_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                const x: IValidationMessage[] = [];
                if (error) {
                    x.push(error);
                }
                tab.validationMessages = x;
            }
            return {
                ...state,
                tabs: currentTabs
            }
        }

        case MP_CREATE_NEW_REGISTERED_WORK: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, registeredWorkMaintenanceGeneralDataViewData } = action.payload;
            const registeredWorkDetailsTab: ITabReduxItem = {
                title: "New Registered Work",
                name: "registerNewWork",
                changesMade: true,
                component: REGISTERED_WORKS_MAINTENANCE_PAGE.component,
                registeredWorkMaintenanceState: {
                    loaded: false,
                    work: WorkDetailsMapper.createNewWorkState(lookups),
                    isNew,
                }
            };
            const tabs = state.tabs.concat(registeredWorkDetailsTab);
            return {
                ...state,
                tabs,
                activeTab: tabs.length - 1
            }
        }
        case MP_COPY_REGISTERED_WORK: {
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            const registeredWorkToCopy = JSON.parse(JSON.stringify(tab.registeredWorkMaintenanceState.work)) as IWorkState;
            const workId = registeredWorkToCopy.workID;
            resetRegisteredWorkIds(registeredWorkToCopy);
            registeredWorkToCopy.workID = 0;
            const newTab: ITabReduxItem = {
                title: undefined,
                component: REGISTERED_WORKS_MAINTENANCE_PAGE.component,
                changesMade: true,
                registeredWorkMaintenanceState: {
                    loaded: false,
                    work: registeredWorkToCopy,
                },
                dataActionToolbar: action.actionList,
            };
            newTab.title = workId > 0 ? "Copy of " + workId : "Copy of New Registered Work";
            const tabs = state.tabs.concat(newTab);
            return {
                ...state,
                tabs: tabs,
                activeTab: tabs.length - 1
            }
        }

        case MP_SEARCH_LIVE_PERFORMANCES_REQUEST:
            return {
                ...state,
                isSearching: true
            };
        case MP_SEARCH_REGISTERED_WORKS_REQUEST: {
            const { isModalSearch } = action.payload;
            return {
                ...state,
                isSearching: true,
                isModalSearch
            };
        }
        case MP_UNDO_REGISTERED_WORK_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            return {
                saveInProgress: true,
                tabs: currentTabs,
                ...state
            }
        }
        case MP_UNDO_REGISTERED_WORK_CHANGES_SUCCESS: {
            const { registeredWork, lookupValues } = action.payload;
            const registeredWorkState = WorkDetailsMapper.mapWorkToWorkState(registeredWork, lookupValues);
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.registeredWorkMaintenanceState) {
                tab.registeredWorkMaintenanceState.work = registeredWorkState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case MP_UNDO_REGISTERED_WORK_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.activeTab];
            if (tab && tab.registeredWorkMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getRegisteredWorkDetailsError = error;

            return newState;
        }
        case MP_SAVE_REGISTERED_WORK_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            return {
                ...state,
                tabs: currentTabs
            };
        }
        case MP_SAVE_REGISTERED_WORK_SUCCESS: {
            const { registeredWorkSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const registeredWork = WorkDetailsMapper.mapWorkToWorkState(registeredWorkSaveResult.work, lookupValues);
                tab.saveSuccessful = registeredWorkSaveResult.success;
                tab.exportSuccessful = false;
                tab.registeredWorkMaintenanceState.work = registeredWork;
                tab.registeredWorkMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            return {
                ...state,
                tabs: currentTabs,
                saveInProgress: false
            };
        }
        case MP_SAVE_REGISTERED_WORK_FAILURE: {
            const { registeredWorkSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.activeTab];
            if (tab) {
                const registeredWork = WorkDetailsMapper.mapWorkToWorkState(registeredWorkSaveResult.work, lookupValues);
                tab.registeredWorkMaintenanceState.work = registeredWork;
                tab.changesMade = !registeredWorkSaveResult.saved;
                tab.saveSuccessful = registeredWorkSaveResult.saved;
                const x: IValidationMessage[] = [];
                registeredWorkSaveResult.messages.map(m => x.push({ messageKey: m.messageKey }));
                tab.validationMessages = x;
            }

            return {
                ...state,
                tabs: currentTabs
            };

        }

        case MP_UPDATE_REGISTERED_WORK_FIELD: {
            const { value, fieldName, subFieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.registeredWorkMaintenanceState && tab.registeredWorkMaintenanceState.work) {
                const registeredWork: any = Object.assign({}, tab.registeredWorkMaintenanceState.work);
                registeredWork[fieldName] = value as Pick<IMembersPortalStateKeys, keyof IMembersPortalStateKeys>
                tab.registeredWorkMaintenanceState.work = registeredWork;
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case MP_SEARCH_REGISTERED_WORKS_SUCCESS: {
            const { registeredWorksResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.registeredWorkSearchResult = registeredWorksResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.isModalSearch = undefined;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_REGISTERED_WORKS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.registeredWorkSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.isModalSearch = undefined;
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_SEARCH_ALL_REGISTERED_WORKS_REQUEST: {
            const { isModalSearch } = action.payload;
            return {
                ...state,
                isSearching: true,
                isModalSearch

            }
        }

        case MP_SEARCH_ALL_REGISTERED_WORKS_SUCCESS: {
            const { allRegisteredWorksResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.allRegisteredWorkSearchResult = allRegisteredWorksResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = undefined;
            return newState;
        }

        case MP_SEARCH_ALL_REGISTERED_WORKS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.allRegisteredWorkSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_GET_REGISTERED_WORK_ID_SUCCESS: {
            const { workIDs } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.registeredWorkIDs = workIDs;
            return newState;
        }
        case MP_SEARCH_REQUEST_ACCESS_IP_SUCCESS: {
            const { contributorsResult } = action.payload;
            const newState: IMembersPortalState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.requestAccessIPSearchResult = contributorsResult;
            return newState;
        }
        case MP_SEARCH_REQUEST_ACCESS_IP_FAILURE: {
            const newState: IMembersPortalState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.requestAccessIPSearchResult = [];
            return newState;
        }

        case MP_SEARCH_LIVE_PERFORMANCES_SUCCESSS: {
            const { livePerformancesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.livePerformanceSearchResults = livePerformancesResult.livePerformances;
            tab.continuationToken = livePerformancesResult.continuationToken
            tab.licenseVenues = []
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            newState.isModalSearch = undefined;
            return newState;
        }

        case MP_SEARCH_LIVE_PERFORMANCES_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.livePerformanceSearchResults = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }

        case GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS: {
            const { defaultLegalEntityValue } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IMembersPortalState = Object.assign({}, state);
            newState.tabs = currentTabs;
            let tab = currentTabs[newState.activeTab];
            if (tab && tab.draftWorkMaintenanceState) {
                tab.draftWorkMaintenanceState.workContributorDefaultLegalEntityValue = defaultLegalEntityValue ?? "L";
            }
            return newState;
        }

        case GET_SHARE_SETS_SHOWN_IN_PORTAL_CONFIG_SUCCESS: {
            const { shareSetsShownInPortal } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.shareSetsShownInPortal = shareSetsShownInPortal;

            return newState;
        }

        case GET_PORTAL_WORK_STATUS_CONFIGURATION_SUCCESS: {
            const { portalWorkStatusConfiguration } = action.payload;

            return {
                ...state,
                portalWorkStatusConfiguration
            };
        }

        case GET_DEFAULT_SET_TYPE_GROUP_CONFIG_SUCCESS: {
            const { defaultSetTypeGroup } = action.payload;
            const newState = JSON.parse(JSON.stringify(state)) as IMembersPortalState;
            newState.defaultSetTypeGroup = defaultSetTypeGroup;
            return newState;
        }

        case MP_UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS: {
            const { workContributorId, ip, agreementChain } = action.payload;
            const newState: IMembersPortalState = JSON.parse(JSON.stringify(state));
            const tab = newState.tabs[newState.activeTab];
            if (tab) {
                tab.changesMade = true;
                const work = tab.draftWorkMaintenanceState.work;
                const defaultLegalEntityValue = tab.draftWorkMaintenanceState.workContributorDefaultLegalEntityValue;
                const flattenedContributors: IContributorItem[] = WorkDetailsMapper.flattenContributors(work.contributors);
                let contributor: IContributorItem;
                if (workContributorId !== null) {
                    contributor = flattenedContributors.find(c => c.workContributorID === workContributorId);
                    clearContributorFields(contributor);
                }
                else {
                    contributor = flattenedContributors.find(c => c.workContributorID === workContributorId && c.name.value.length == 0 && c.ipiNumber.value.length == 0);
                }

                if (contributor) {
                    contributor.ipiNumber.value = ip.ipiNumber && ip.ipiNumber.toString();
                    contributor.accountNumber.value = ip.accountNumber;
                    contributor.ipBaseNumber = ip.ipBaseNumber;
                    contributor.name.value = ip.ipName;
                    contributor.agreementChain = agreementChain;
                    contributor.societyOfLicense.value = ip.societyOfLicense;
                    contributor.mechSocietyAffiliation.value = ip.mechSocietyAffiliation;
                    contributor.perfSocietyAffiliation.value = ip.perfSocietyAffiliation;

                    if (ip.legalEntityType && (ip.legalEntityType === defaultLegalEntityValue)) {
                        contributor.role = { value: 'E', inputType: DROPDOWN_INPUT }
                    }
                    else {
                        contributor.role = { value: 'CA', inputType: DROPDOWN_INPUT }
                    }

                    updateInheritedContributors(work, contributor.setType);
                }
            }
            return newState;
        }

        case MP_SEARCH_CONTRIBUTORS_SUCCESS: {
            const { contributorsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.contributorsSearchResult = contributorsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_CONTRIBUTORS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.contributorsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;

        }

        case MP_SEARCH_ARTISTS_SUCCESS: {
            const { artistsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.artistsSearchResult = artistsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_ARTISTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.artistsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_ADD_ARTIST_TO_WORK: {
            const { artist, id } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            tab.changesMade = true;
            if (state.dataSource == DataSource.Intray) {
                let work = tab.draftWorkMaintenanceState.work;
                let performer = work.artists.find(a => a.workPerformerID === id)
                if (performer) {
                    performer.firstName.value = artist.firstName && artist.firstName.value ? artist.firstName.value : (artist.firstName ? String(artist.firstName) : null);
                    performer.lastName.value = artist.lastName && artist.lastName.value ? artist.lastName.value : (artist.lastName ? String(artist.lastName) : null);
                    performer.fullName.value = artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null);
                    performer.type.value = artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null);
                    performer.number.value = artist.number && artist.number.value ? artist.number.value : (artist.number ? String(artist.number) : null);
                    performer.performerID = artist.performerID;
                }
            }
            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;
        }

        case MP_GET_DRAFT_WORK_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftWork: true,
                getDraftWorkDetailsError: undefined
            };
        }
        case MP_GET_DRAFT_WORK_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftWork: false,
                getDraftWorkDetailsError: undefined
            };
        case MP_GET_DRAFT_WORK_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftWork: false,
                getDraftWorkDetailsError: { id: action.payload.workId, error: action.payload.error }
            };
        case MP_GET_DRAFT_SET_LIST_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftSetList: true,
                getDraftSetListDetailsError: undefined
            };
        }
        case MP_GET_DRAFT_SET_LIST_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftSetList: false,
                getDraftSetListDetailsError: undefined
            };
        case MP_GET_DRAFT_SET_LIST_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftSetList: true,
                getDraftSetListDetailsError: undefined
            };
        }
        case MP_GET_CUE_SHEET_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftSetList: false,
                getDraftSetListDetailsError: undefined
            };
        case MP_GET_CUE_SHEET_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftSetList: false,
                getDraftSetListDetailsError: { id: action.payload.productCoreId, error: action.payload.error }
            };
        case MY_PACKAGES_DOWNLOAD_FORMAT_SUCCESS: {
            const { downloadFileFormat } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.downloadFileFormat = downloadFileFormat;
            }
            newState.tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case MP_GET_DRAFT_SET_LIST_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftSetList: false,
                getDraftSetListDetailsError: { id: action.payload.productCoreId, error: action.payload.error }
            };
        case MP_ADD_REPERTOIRE_ATTACHMENT_SUCCESS: {
            const { attachment, tabId } = action.payload;
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex];

            if (tab) {
                if (tab.draftWorkMaintenanceState) {
                    if (tab.draftWorkMaintenanceState.work) {
                        if (tab.draftWorkMaintenanceState.work.files) {
                            if (attachment) {
                                tab.draftWorkMaintenanceState.work.files.push({
                                    fullName: `repertoireAttachments/work/${attachment.guid}`,
                                    inProgress: false,
                                    isDirectory: false,
                                    isDirty: false,
                                    isEditing: false,
                                    lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                                    sources: [],
                                    metadata: undefined,
                                    name: attachment.fileName,
                                    pools: [],
                                    formats: [],
                                    distributions: [],
                                    validationError: undefined
                                });
                            }
                        }
                        else {
                            tab.draftWorkMaintenanceState.work.files = [];
                        }
                    }
                }
                else if (tab.livePerformanceMaintenanceState) {
                    if (tab.livePerformanceMaintenanceState.usageGroup) {
                        if (tab.livePerformanceMaintenanceState.usageGroup.files) {
                            if (!tab.livePerformanceMaintenanceState.usageGroup.files) {
                                tab.livePerformanceMaintenanceState.usageGroup.files = [];
                            }
                            if (attachment) {
                                tab.livePerformanceMaintenanceState.usageGroup.files.push({
                                    fullName: `repertoireAttachments/usage/${attachment.guid}`,
                                    inProgress: false,
                                    isDirectory: false,
                                    isDirty: false,
                                    isEditing: false,
                                    lastModified: formatAttachmentLastModifiedForDisplay(new Date()),
                                    sources: [],
                                    metadata: undefined,
                                    name: attachment.fileName,
                                    pools: [],
                                    formats: [],
                                    distributions: [],
                                    validationError: undefined
                                });
                            }
                        }
                    }
                }
                else if (tab.agreementMaintenanceState) {
                    if (tab.agreementMaintenanceState.agreement) {
                        if (tab.agreementMaintenanceState.agreement.files) {
                            if (!tab.agreementMaintenanceState.agreement.files) {
                                tab.agreementMaintenanceState.agreement.files = [];
                            }
                            if (attachment) {
                                tab.agreementMaintenanceState.agreement.files.push({
                                    fullName: `repertoireAttachments/agreements/${attachment.guid}`,
                                    inProgress: false,
                                    isDirectory: false,
                                    isDirty: false,
                                    isEditing: false,
                                    lastModified: formatAttachmentLastModifiedForDisplay(new Date()),
                                    sources: [],
                                    metadata: undefined,
                                    name: attachment.fileName,
                                    pools: [],
                                    formats: [],
                                    distributions: [],
                                    validationError: undefined
                                });
                            }
                        }
                    }
                }
                else if (tab.uploadCueSheetsMaintenanceState) {
                    if (tab.uploadCueSheetsMaintenanceState.uploadedCueSheetsInputFiles) {
                        if (attachment) {
                            tab.uploadCueSheetsMaintenanceState.uploadedCueSheetsInputFiles.push({
                                fullName: `repertoire/portalcues/input/${attachment.guid}`,
                                inProgress: false,
                                isDirectory: false,
                                isDirty: false,
                                isEditing: false,
                                lastModified: formatAttachmentLastModifiedForDisplay(new Date()),
                                sources: [],
                                metadata: undefined,
                                name: attachment.fileName,
                                pools: [],
                                formats: [],
                                distributions: [],
                                validationError: undefined
                            });
                        }
                    }
                }

            }

            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_REMOVE_WORK_ATTACHMENT_SUCCESS: {
            const { attachment, tabId } = action.payload;
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex];
            let newFiles = [];

            if (tab) {
                if (tab.draftWorkMaintenanceState) {
                    if (tab.draftWorkMaintenanceState.work) {
                        if (tab.draftWorkMaintenanceState.work.files) {
                            if (!tab.draftWorkMaintenanceState.work.files) {
                                tab.draftWorkMaintenanceState.work.files = [];
                            }
                            if (attachment) {
                                if (tab.draftWorkMaintenanceState.work.files.find(x => x.name === attachment.fileName)) {
                                    newFiles = tab.draftWorkMaintenanceState.work.files.filter(x => x.name != attachment.fileName);
                                    tab.draftWorkMaintenanceState.work.files = newFiles;
                                }
                            }
                        }
                    }
                }
                else if (tab.livePerformanceMaintenanceState) {
                    if (tab.livePerformanceMaintenanceState.usageGroup) {
                        if (tab.livePerformanceMaintenanceState.usageGroup.files) {
                            if (!tab.livePerformanceMaintenanceState.usageGroup.files) {
                                tab.livePerformanceMaintenanceState.usageGroup.files = [];
                            }
                            if (attachment) {
                                if (tab.livePerformanceMaintenanceState.usageGroup.files.find(x => x.fullName === attachment.fileName)) {
                                    newFiles = tab.livePerformanceMaintenanceState.usageGroup.files.filter(x => x.fullName != attachment.fileName);
                                    tab.livePerformanceMaintenanceState.usageGroup.files = newFiles;
                                }
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_REMOVE_AGREEMENT_ATTACHMENT_SUCCESS: {
            const { attachment, tabId } = action.payload;
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex];
            let newFiles = [];

            if (tab?.agreementMaintenanceState?.agreement?.files && attachment) {
                if (tab.agreementMaintenanceState.agreement.files.find(x => x.name === attachment.fileName)) {
                    newFiles = tab.agreementMaintenanceState.agreement.files.filter(x => x.name != attachment.fileName);
                    tab.agreementMaintenanceState.agreement.files = newFiles;
                }
            }
            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_ADD_DROPPED_FILE: {
            const { file, inProgress, tabId } = action.payload;
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;
            const currentTab = state.tabs[tabIndex];
            if (!currentTab) return state;

            const files = inProgress
                ? [...currentTab.droppedFiles.files, file]
                : currentTab.droppedFiles.files.filter(
                    f => !(f.name === file.name && f.size === file.size)
                );

            const updatedTab = {
                ...currentTab,
                droppedFiles: {
                    ...currentTab.droppedFiles,
                    files
                }
            };

            const tabs = state.tabs.map((tab, index) =>
                index === tabIndex ? updatedTab : tab
            );

            return { ...state, tabs: tabs };
        }
        case MP_SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE: {
            const { message, file, isUploadComplete, tabId } = action.payload;
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex];
            if (!tab) return state;
            const newState = tab.droppedFiles as IDroppedFiles;

            const existedFile: IFile = newState.files.find(f => f.name === file.name);

            if (existedFile) {
                const fileIndex = newState.files.indexOf(existedFile);
                if (fileIndex > -1) {
                    newState.files[fileIndex].message = message;

                    if (isUploadComplete)
                        newState.files[fileIndex].isInProgress = false;
                }
            }

            return { ...state, tabs: currentTabs }
        }
        case MP_CLEAN_DROPPED_FILES_STATE: {
            const { tabId } = action.payload || {};
            const tabIndex = tabId ? state.tabs.findIndex(t => t.tabId === tabId) : state.activeTab;
            if (tabId && tabIndex === -1) return state;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex];
            if (!tab) return state;
            tab.droppedFiles = {
                files: [],
                inDropZone: false
            };

            return {
                ...state,
                tabs: currentTabs
            }
        }

        case MP_GET_REGISTERED_WORK_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftWork: true,
                getRegisteredWorkDetailsError: undefined
            };
        }

        case MP_GET_REGISTERED_WORK_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftWork: false,
                getRegisteredWorkDetailsError: undefined
            };

        case MP_GET_REGISTERED_WORK_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftWork: false,
                getRegisteredWorkDetailsError: { id: action.payload.workId, error: action.payload.error }
            };

        case MP_GET_REGISTERED_SET_LIST_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftSetList: true,
                getRegisteredSetListDetailsError: undefined
            };
        }

        case MP_GET_REGISTERED_SET_LIST_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftSetList: false,
                getRegisteredSetListDetailsError: undefined
            };

        case MP_GET_REGISTERED_SET_LIST_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftWork: false,
                getRegisteredSetListDetailsError: { id: action.payload.productCoreId, error: action.payload.error }
            };

        case MP_GET_FULL_CATALOGUE_PACKAGE_PENDING_SUCCESS: {
            const { myPackagesDetails } = action.payload;

            const fullCataloguePackagePending =
                Array.isArray(myPackagesDetails) &&
                myPackagesDetails.some(packageItem =>
                    packageItem?.entityType === "Works" &&
                    packageItem?.status === "Open" &&
                    Boolean(packageItem?.searchCriteriaJson)
                );
            return {
                ...state,
                fullCataloguePackagePending
            };
        }

        case MP_CREATE_PACKAGE_FROM_CRITERIA_REQUEST: {
            return {
                ...state,
                packageOperationInProgress: true,
            };
        }

        case MP_CREATE_PACKAGE_FROM_CRITERIA_SUCCESS: {
            const { result } = action.payload;
            const createdPackage = result?.MyPackages;

            const tabs = state.tabs.map(tab => {
                const existingResult: any = tab.myPackagesResult;

                const existingPackages =
                    Array.isArray(existingResult)
                        ? existingResult
                        : Array.isArray(existingResult?.data)
                            ? existingResult.data
                            : [];

                return {
                    ...tab,
                    myPackagesResult: createdPackage
                        ? [
                            createdPackage,
                            ...existingPackages.filter(
                                packageItem =>
                                    String(packageItem.id) !==
                                    String(createdPackage.id)
                            ),
                        ]
                        : existingResult,
                };
            });

            return {
                ...state,
                tabs,
                packageOperationInProgress: false,
                fullCataloguePackagePending:
                    createdPackage?.entityType === "Works"
                        ? true
                        : state.fullCataloguePackagePending,
            };
        }

        case MP_CREATE_PACKAGE_FROM_CRITERIA_FAILURE: {
            const { result } = action.payload;
            return {
                ...state,
                packageOperationInProgress: false
            };
        }

        case MP_GET_ASSIGNEE_AGREEMENTS_REQUEST:
            return {
                ...state,
                isSearching: true
            };

        case MP_GET_ASSIGNEE_AGREEMENTS_SUCCESS: {
            return {
                ...state,
                isSearching: false,
                assigneeAgreementsResult: action.payload.assigneeAgreementsResult
            };
        }

        case MP_GET_ASSIGNEE_AGREEMENTS_FAILURE:
            return {
                ...state,
                isSearching: false
            };

        case MP_GET_ALL_REGISTERED_WORK_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingDraftWork: true,
                getAllRegisteredWorkDetailsError: undefined
            };
        }

        case MP_GET_ALL_REGISTERED_WORK_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingDraftWork: false,
                getAllRegisteredWorkDetailsError: undefined
            };
        case MP_GET_ALL_REGISTERED_WORK_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingDraftWork: false,
                getAllRegisteredWorkDetailsError: { id: action.payload.workId, error: action.payload.error }
            };
        case MP_REQUEST_VIEW_AS_ACCESS_SUCCESS:
            return {
                ...state,
                requestingViewAsAccess: false,
                requestViewAsAccessSuccess: action.payload.success
            };
        case MP_REQUEST_VIEW_AS_ACCESS_FAILURE:
            return {
                ...state,
                requestingViewAsAccess: false,
                requestViewAsAccessSuccess: action.payload.error
            };
        case MP_GET_VIEW_AS_ACCESS_REQUESTS_SUCCESS:
            return {
                ...state,
                viewAsAccessRequests: action.payload.viewAsAccessRequests
            };
        case MP_GET_VIEW_AS_ACCESS_REQUESTS_FAILURE:
            return {
                ...state,
            };
        case MP_GET_MY_APPLICATIONS_SUCCESS:
            return {
                ...state,
                myApplications: action.payload.applications
            };
        case MP_GET_MY_APPLICATIONS_FAILURE:
            return {
                ...state,
            };
        case MP_GET_MY_CASES_SUCCESS:
            return {
                ...state,
                myCases: action.payload.cases
            };
        case MP_GET_MY_CASES_FAILURE:
            return {
                ...state,
            };
        case MP_SAVE_VIEW_AS_ACCESS:
            return {
                ...state,
            };
        case MP_SAVE_VIEW_AS_ACCESS_SUCCESS: {
            const newState = Object.assign({}, state);

            newState.viewAsAccessRequests = action.payload.viewAsAccessRequests;
            newState.viewAsAccessSaveSuccess = action.payload.viewAsAccessSaveSuccess;
            newState.tabs = [];
            newState.activeTab = 0;

            return newState;
        }
        case MP_SAVE_VIEW_AS_ACCESS_FAILURE:
            return {
                ...state,
            };
        case MP_CANCEL_ACCESS_REQUEST_SUCCESS:
            const { accountNumber } = action.payload;

            const viewAsAccess = state.viewAsAccessRequests;
            const updatedViewAsAccessRequests = viewAsAccess.filter(x => x.accountNumber !== accountNumber);

            return {
                ...state,
                cancelAccessRequestSuccess: action.payload.cancelAccessRequestSuccess,
                viewAsAccessRequests: updatedViewAsAccessRequests
            };
        case MP_CANCEL_ACCESS_REQUEST_FAILURE:
            return {
                ...state,
            };
        case MP_RESET_VIEW_AS_SAVE_STATUS:
            return {
                ...state,
                viewAsAccessSaveSuccess: undefined,
                cancelAccessRequestSuccess: undefined
            }
        case MP_REGISTER_STEPS_SET_CURRENT:
            const { current } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);
            tab.registerStepsCurrent = current;

            newState.tabs = currentTabs;

            return newState;

        case MP_EXPAND_STATEMENT_RESULT: {
            const { statementResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.activeTab];

            if (tab) {
                if (tab.expandedMemberStatementResults && tab.expandedMemberStatementResults.includes(statementResult)) {
                    tab.expandedMemberStatementResults.splice(tab.expandedMemberStatementResults.indexOf(statementResult), 1);
                }
                else {
                    if (tab.expandedMemberStatementResults === undefined) {
                        tab.expandedMemberStatementResults = [];
                    }
                    tab.expandedMemberStatementResults.push(statementResult);
                }
            }

            return {
                ...state,
                tabs: currentTabs
            }
        }
        case MP_SEARCH_UNPAID_CLAIMS_REQUEST: {
            return {
                ...state,
                isSearching: true
            }
        }
        case MP_SEARCH_UNPAID_CLAIMS_SUCCESS: {
            const { unpaidClaimsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.unpaidClaimsSearchResults = unpaidClaimsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_CLAIM_UNPAID_USAGE_SUCCESS: {

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            if (tab) {
                tab.showUnpaidUsageClaimSuccessBanner = true;
            }

            newState.tabs = currentTabs;
            return newState;

        }
        case MP_SEARCH_UNPAID_CLAIMS_FAILURE: {
            return {
                ...state,
                isSearching: false
            }
        }

        case MP_SEARCH_CLAIMS_HISTORY_REQUEST: {
            return {
                ...state,
                isSearching: true
            }
        }
        case MP_SEARCH_CLAIMS_HISTORY_SUCCESS: {
            const { claimsHistoryResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            tab.claimsHistorySearchResults = claimsHistoryResult;
            tab.currentPage = 1;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_SEARCH_CLAIMS_HISTORY_FAILURE: {
            return {
                ...state,
                isSearching: false
            }
        }
        case MP_SEARCH_STATEMENTS_SUCCESS: {
            const { statementsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            const newState = Object.assign({}, state);

            let results = statementsResult.map(s => ({ ...s, amountEarned: s.amountEarned.toString(), amountPaid: s.amountPaid.toString() }))
            tab.memberStatementSearchResults = results;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_RESET_MESSAGE_BANNER: {
            const currentTabs: ITabReduxItem[] = [];

            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));

            let tab = currentTabs[state.activeTab];

            if (tab) {

                tab.saveSuccessful = undefined;

                tab.validationMessages = undefined;

                tab.addRepresentationSuccessful = true;

                tab.showAddRepresentationBanner = false;

                tab.validateRepresentationUnsuccessful = false;

                tab.showSearchLastPercentageWarningBanner = false;

            }

            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;

        }
        case MP_ADD_WORK_TO_SET_LIST: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            if (tab && tab.draftSetListsMaintenanceState && tab.draftSetListsMaintenanceState.setLists) {
                if (!tab.draftSetListsMaintenanceState.setLists.productWork) {
                    tab.draftSetListsMaintenanceState.setLists.productWork = [];
                }

                tab.draftSetListsMaintenanceState.setLists.productWork.push({
                    productWorkID: 0,
                    workCode: work.workID,
                    title: { value: work.title[0] ? work.title[0] : null, inputType: READ_ONLY_INPUT },
                    number: { value: work.workNumber[0] ? work.workNumber[0] : null, inputType: READ_ONLY_INPUT },
                    writer: { value: work.contributors[0] ? work.contributors[0] : null, inputType: READ_ONLY_INPUT },
                    duration: {
                        value: work.duration && work.duration !== 0
                            ? work.duration
                            : (tab.draftSetListsMaintenanceState.setLists.defaultWorkDuration ?? 0),
                        inputType: TIMESPAN_INPUT
                    },
                    artist: { value: work.performers[0] ? work.performers[0] : null, inputType: READ_ONLY_INPUT },
                    intrayIndicator: { value: work.dataSource === INTRAY ? true : false, inputType: BOOLEAN_READONLY_INPUT },
                    status: { value: work.status, inputType: READ_ONLY_INPUT }
                });
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_ADD_SET_LIST_TO_LIVE_PERFORMANCE: {
            const { setList } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];
            if (tab && tab.livePerformanceMaintenanceState && tab.livePerformanceMaintenanceState.usageGroup) {
                tab.livePerformanceMaintenanceState.usageGroup.livePerformanceSetList = setList;
                tab.livePerformanceMaintenanceState.usageGroup.matchingProducts = [
                    {
                        status: setList.productStatus,
                        matchType: DEFINITE_MATCH,
                        type: setList.type,
                        id1: setList.id1,
                        id2: setList.id2,
                        title: setList.title,
                        source: setList.source,
                        artist: setList.artist,
                        contributor: setList.contributor,
                        productCoreID: setList.productCoreID,
                        number: setList.number
                    }
                ];
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;
        }
        case MP_GET_LIVE_PERFORMANCE_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingLivePerformance: true,
                getLivePerformanceDetailsError: undefined
            };
        }
        case MP_GET_LIVE_PERFORMANCE_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingLivePerformance: false,
                getLivePerformanceDetailsError: undefined
            };
        case MP_GET_LIVE_PERFORMANCE_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingLivePerformance: false,
                getLivePerformanceDetailsError: { id: action.payload.usageId, error: action.payload.error }
            };
        case MP_GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS: {
            const { decimalsToDisplay } = action.payload;

            return {
                ...state,
                shareDecimalsToDisplay: decimalsToDisplay
            };
        }
        case MP_SAVE_WORK_CONTRIBUTOR_COMMENT: {

            const { contributorID, comments } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.activeTab];

            if (tab) {

                const work = state.tabs[state.activeTab].draftWorkMaintenanceState.work

                const flattenedContributors: IContributorItem[] = WorkDetailsMapper.flattenContributors(work.contributors);
                let contributor: IContributorItem;
                if (contributorID !== null) {
                    contributor = flattenedContributors.find(c => c.workContributorID === contributorID);
                    contributor.comments = comments;
                }

                tab.changesMade = true;
            }

            const newState = Object.assign({}, state);
            newState.tabs = currentTabs;
            return newState;

        }
        case MP_GET_CRM_INTEGRATION_ENABLED_SUCCESS: {
            const { crmIntegrationEnabled } = action.payload;

            return {
                ...state,
                isCRMIntegrationEnabled: crmIntegrationEnabled,
            };
        }
        case MP_GET_CRM_POWER_PORTAL_BASE_URL_SUCCESS: {
            const { crmPowerPortalBaseURL } = action.payload;

            return {
                ...state,
                powerPortalURL: crmPowerPortalBaseURL,
            };
        }
        case GET_ENABLED_SET_TYPE_BUNDLE_REQUEST: {
            return {
                ...state,
            }
        }
        case GET_ENABLED_SET_TYPE_BUNDLE_SUCCESS: {
            const { enableSetTypeBundle } = action.payload;
            return {
                ...state,
                enableSetTypeBundle
            }
        }
        case GET_ENABLED_SET_TYPE_BUNDLE_FAILURE: {
            return {
                ...state,
            }
        }
        case MP_GET_STATEMENT_POWERBI_EMBED_REQUEST: {
            return {
                ...state,
            }
        }
        case MP_GET_STATEMENT_POWERBI_EMBED_SUCCESS: {
            return {
                ...state,
                powerBIEmbedParams: action.payload.powerBIEmbedParams
            }
        }
        case MP_GET_STATEMENT_POWERBI_EMBED_FAILURE: {
            return {
                ...state,
            }
        }
        case MP_RESET_POWER_BI_EMBED_TOKEN: {
            return {
                ...state,
                powerBIEmbedParams: undefined
            }
        }
        case MP_GET_POWER_BI_ANALYTICS_CONFIGURATION_SUCCESS: {
            const { powerBIAnalyticsConfig } = action.payload;

            return {
                ...state,
                powerBIAnalyticsConfig,
            };
        }
        default:
            return state;
    }
};

// TODO: Consider using this reusable component in other reducers
const updateTabField = (
    state: IMembersPortalState,
    field: keyof ITabReduxItem,
    value: any,
    searchSuccessful: boolean
): IMembersPortalState => {
    const clonedTabs = state.tabs.map(tab => ({ ...tab }));
    const tab = clonedTabs[state.activeTab];

    return {
        ...state,
        searchSuccessful,
        isSearching: false,
        tabs: clonedTabs,
        ...(tab && { tabs: clonedTabs.map((t, i) => i === state.activeTab ? { ...t, [field]: value } : t) })
    };
};

export default membersPortalReducer;
